/*
  Extracted from snippets/params-foodify.liquid, which inlined this into
  every cart, collection, product and search page. Inline script is never
  cached and never shared across navigations; this file is both.
  Liquid values arrive via window.FOODIFY_CONFIG.
*/

var CFG = window.FOODIFY_CONFIG || {};

console.log('[ FOODIFY - v2.0 ]');

// Server-rendered foodify buttons (data-custom-open) are clickable as soon as
// the markup paints; this delegated handler opens the modal until the per-card
// wiring takes over (marked via data-foodify-wired).
document.addEventListener('click', (event) => {
  const btn = event.target.closest && event.target.closest('.atc-nextgen button[data-custom-open]');
  if (!btn || btn.dataset.foodifyWired) return;
  event.preventDefault();
  try { MicroModal.show(btn.getAttribute('data-custom-open')); } catch (err) { console.error(err); }
});

window.waitForElmFoodify = (selector) =>
  new Promise((resolve) => {
    const resolveIfFound = () => {
      const element = document.querySelector(selector);
      if (element) {
        observer.disconnect();
        resolve(element);
      }
    };

    if (document.querySelector(selector)) {
      return resolve(document.querySelector(selector));
    }

    const observer = new MutationObserver((mutations) => {
      resolveIfFound();
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });
  });

class Timer {
  constructor() {
    this.timers = {};
  }

  start(name) {
    if (!this.timers[name]) {
      this.timers[name] = { start: performance.now(), elapsed: 0 };
    }
  }

  stop(name) {
    if (this.timers[name]) {
      const elapsed = performance.now() - this.timers[name].start;
      this.timers[name].elapsed = elapsed;
      const seconds = (elapsed / 1000).toFixed(2);
      const ms = elapsed.toFixed(3);
    //-console.log(`${name}: ${seconds}s (${ms}ms)`);
      delete this.timers[name];
    }
  }
}

const timer = new Timer();
timer.start('INSERT');



var scriptSrc = CFG.microModalSrc;
if (!document.querySelector(`script[src="${scriptSrc}"]`)) {
    var script = document.createElement('script');
    script.src = scriptSrc;
    script.defer = true;
    document.head.appendChild(script);
}

document.addEventListener('DOMContentLoaded', function () {
  waitForElmFoodify(`.button[data-custom-open]`).then(() => {
      MicroModal.init({
          // onShow: modal => console.info(`${modal.id} is shown`),
          // onClose: modal => console.info(`${modal.id} is hidden`),
          openTrigger: 'data-custom-open',
          closeTrigger: 'data-micromodal-close',
          openClass: 'is-open',
          disableScroll: true,
          disableFocus: false,
          awaitOpenAnimation: false,
          awaitCloseAnimation: false,
          debugMode: true
      });
  });   
});
  


  //////////////////////////////////////////////////////////
  if (CFG.customerLoggedIn) window.customerLoggedIn = true;
  const enableTestMode = CFG.enableTestMode;
  const normal_bg_color = CFG.normalBgColor;
  const highlight_bg_color = CFG.highlightBgColor;
  const normal_text_color = CFG.normalTextColor;
  const highlight_text_color = CFG.highlightTextColor;
  const useArrow = CFG.useArrow;
  const requireLoginFoodify = CFG.requireLoginFoodify;
  //////////////////////////////////////////////////////////

  function parseFoodifyOptions(jsonStr) {
    if (!jsonStr || jsonStr === '' || jsonStr === 'null') return null;
    try {
      return typeof jsonStr === 'object' ? jsonStr : JSON.parse(jsonStr);
    } catch(e) {
      console.error('Foodify: Failed to parse options JSON', e);
      return null;
    }
  }

  //////////////////////////////////////////////////////////
  // METAFIELD-BASED DATA LOADING (replaces Gadget API fetch)
  //////////////////////////////////////////////////////////
  let storeData = [{ sandwiches: [] }];
  let itemProductData = undefined;

  if (CFG.productOptions) {
    const pdpOptionsRaw = CFG.productOptions;
    const pdpOptions = parseFoodifyOptions(pdpOptionsRaw);
    if (pdpOptions) {
      itemProductData = pdpOptions;
      itemProductData.id = String(itemProductData.id || CFG.productId);
      storeData = [{ sandwiches: [itemProductData] }];
    }
  }

  const sandwichIds = storeData[0].sandwiches.map(s => s.id);
  window.sandwichIds = sandwichIds;

  document.addEventListener('DOMContentLoaded', () => {
    preliminary(storeData, itemProductData);
  });
  

  //////////////////////////////////////////////////////////
  function preliminary(storeData, itemProductData) {
    if(window.location.href.includes("/cart")) {
      //////////////////////////////////////////////////////////
      waitForElmFoodify(`.cart-order__summary .line-item-x`).then(() => {
         let lineItems = document.querySelectorAll('.cart-order__summary .line-item-x'); // console.log(lineItems);
         lineItems.forEach((lineItem, index) => {
           let lineId = lineItem.getAttribute('data-line-id')
           let productId = lineItem.getAttribute('data-product-id')
           let productTitle = lineItem.getAttribute('data-product-title')
           let productSKU = lineItem.getAttribute('data-product-sku')
           let lineItemKey = lineItem.getAttribute('data-line-key')
           let editButton = lineItem.querySelector('.edit-button-item')
           let lineItemProperties = lineItem.getAttribute('data-foodify-properties')
           let lineItemModal = lineItem.querySelector('.modal')
           // console.log(editButton); console.log(lineItem); console.log(productId);
           
           let singleProductData = { lineId, productId, productTitle, productSKU, lineItemKey }; // console.log("foodify ", index, lineId, productId, singleProductData)
           let foodifyOptionsAttr = lineItem.getAttribute('data-foodify-options');
           let itemProductData = null;
           if (foodifyOptionsAttr) {
             const parsedOpts = parseFoodifyOptions(foodifyOptionsAttr);
             if (parsedOpts) {
               itemProductData = parsedOpts;
               itemProductData.id = String(itemProductData.id || productId);
               storeData = [{ sandwiches: [itemProductData] }];
             }
           }

           if(itemProductData){
             window.hasSandwich = true;
             if(editButton){ editButton.style.display= 'flex'; }
             generateProductOptions(storeData, itemProductData, true, lineId, singleProductData)

             // TODO: Change to find out when it's ready to fill
             setTimeout(()=>{ fillModal(lineItem, lineItemProperties, lineItemModal) },'1000')
           }
           else {
             if(lineItem.querySelector('.edit-button-item ')) { lineItem.querySelector('.edit-button-item ').remove() }
           }
         });
       });
      //////////////////////////////////////////////////////////
    }
    else if((window.location.href.includes("/collections") && !window.location.pathname.includes("/products/")) || window.location.href.includes("/search")) {
        // console.log("on collection || on search")
        //////////////////////////////////////////////////////////////////////////
        const section = document.querySelector('section.shopify-section--main-collection');
        // Load items as they come into view
        const observer = new IntersectionObserver((entries) => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              const lineItem = entry.target;
              let productId = lineItem.getAttribute('data-product-id');
              const foodifyOptionsAttr = lineItem.getAttribute('data-foodify-options');
              let itemProductData = null;
              if (foodifyOptionsAttr) {
                const parsedOpts = parseFoodifyOptions(foodifyOptionsAttr);
                if (parsedOpts) {
                  itemProductData = parsedOpts;
                  itemProductData.id = String(itemProductData.id || productId);
                  storeData = [{ sandwiches: [itemProductData] }];
                }
              }
              if(itemProductData){
                window.hasSandwich = true;
                waitForElmFoodify(`.atc-nextgen button > div`).then(() => {
                  let customizeText = lineItem.querySelector('.atc-nextgen button > div');
                  if(customizeText){
                    // Tile cards (product-card-tile.liquid) render their own
                    // "+ Add" pill server-side — only wire the click, keep the label.
                    const isTileAdd = !!customizeText.closest('[data-tile-add]');
                    if(isTileAdd) {
                      // label untouched
                    } else if(useArrow) {
                      customizeText.innerHTML = `<div style="margin: auto; display: flex; justify-content: center;">${CFG.arrowIcon}</div>`;
                    }else {
                      customizeText.textContent = 'Add to cart';
                    }

                    let customizeBtn = lineItem.querySelector('.atc-nextgen button');
                    let collection = document.querySelector('.shopify-section--main-collection .container .collection');
                    if(collection){ collection.style.opacity = "1"; }
                    let quantity = lineItem.querySelector('form.shopify-product-form > quantity-selector');
                    if(quantity){ quantity.style.display = "none"; }

                    customizeBtn.setAttribute("data-custom-open", `modal-${productId}`); // console.log(customizeBtn)
      
                    if(customizeBtn && !customizeBtn.dataset.foodifyWired){
                      customizeBtn.dataset.foodifyWired = 'true';
                      customizeBtn.setAttribute("aria-controls", ``);
                      customizeBtn.addEventListener('click', (event) => {
                        event.preventDefault();
                        try{MicroModal.show(`modal-${productId}`);}catch(err){console.error(err)}
                      });
                    }
                  }
                });
                let singleProductData = {
                  lineId: lineItem.getAttribute('data-line-id'),
                  productId,
                  productTitle: lineItem.getAttribute('data-product-title'),
                  productSKU: lineItem.getAttribute('data-product-sku'),
                  lineItemKey: lineItem.getAttribute('data-line-key')
                };
      
                waitForElmFoodify(`#modal-${productId} .options-foodify-container`).then(() => {
                  generateProductOptions(storeData, itemProductData, true, productId, singleProductData, lineItem);
                });
     
              } 
              else {
                if(lineItem.querySelector('.edit-button-item')){ lineItem.querySelector('.edit-button-item').remove(); }
                let foodModal = lineItem.querySelector('.modal');
                if(foodModal){ foodModal.remove(); }
              }
              observer.unobserve(lineItem);
            }
          });
        }, { rootMargin: '0px', threshold: 0.1 });
        function observeNewProductCards() {
          const lineItems = document.querySelectorAll('product-list product-card.collection-item-x:not([data-observed])');
          lineItems.forEach(lineItem => {
            lineItem.setAttribute('data-observed', 'true');
            observer.observe(lineItem);
          });
        }
        observeNewProductCards();
        const mutationObserver = new MutationObserver((mutations) => {
          mutations.forEach(mutation => {
            if (mutation.type === 'childList') {
              observeNewProductCards();
            }
          });
        });
        mutationObserver.observe(section, { childList: true, subtree: true });
        //////////////////////////////////////////////////////////
    }
    else {
      if (itemProductData !== undefined) {
          window.hasSandwich = true;
          generateProductOptions(storeData, itemProductData);
       }
     }   
  }
  //////////////////////////////////////////////////////////

  /*  Create The Products Options & Insert  */
  function generateProductOptions(storeData, optionsData, forMultiple = false, itemSelector = '', singleProductData, productElement) {
     ///////////////////////////////////////////////////////////////
     // if(singleProductData){console.log("Generate > ",singleProductData.productTitle, productElement)}
  
     const productOptionsContainer = document.createElement('div');
     productOptionsContainer.id = 'product-options';
     productOptionsContainer.setAttribute('data-base', CFG.variantPrice ||  productElement?.getAttribute('data-product-price') || optionsData.basePrice || '0');
     productOptionsContainer.setAttribute('data-base-default', CFG.productPrice ||  productElement?.getAttribute('data-product-price') || optionsData.basePrice || '0');
     const style = document.createElement('style');
     style.type = 'text/css';
     style.innerHTML = `input.knhjd-pic[type="radio"]:checked + label { outline: 4px solid ${normal_bg_color}; } input.knhjd-pic[type="checkbox"]:checked + label { outline: 4px solid ${normal_bg_color}; }`;
     document.head.appendChild(style);

     const sortedCategories = Object.keys(optionsData.options).sort((a, b) => (optionsData.options[a].sortIndex || Infinity) - (optionsData.options[b].sortIndex || Infinity));

 
     sortedCategories.forEach(categoryName => {
        const category = optionsData.options[categoryName];
        // console.log(category.sortIndex)
        const categoryOptions = category.items;
       // console.log(categoryOptions)
        const categoryType = category.type;
        const categoryId = category.id;
        if (!categoryOptions || categoryOptions.length === 0) return;
        const fieldset = document.createElement('fieldset');
        fieldset.className = 'product-option';
        fieldset.id = categoryId;
        fieldset.classList.add('foodify-fieldset');
        fieldset.dataset.type = categoryName.toLowerCase().split(" ").join("-");
        fieldset.dataset.id = categoryName.toLowerCase().split(" ").join("-");
        const showByDefault = category.showByDefault;
        if (showByDefault === 'false' || showByDefault === false) {
           fieldset.style.display = 'none';
           fieldset.dataset.notIncluded = true;
        }
        const legend = document.createElement('legend');
        legend.className = 'form__label';
        legend.textContent = (categoryType === 'select' || category.required) ? `${categoryName}: *` : `${categoryName}:`;
        if (categoryType === 'checkbox' && category.required) {
           fieldset.dataset.required = category.required;
        }
        if (category.helpText && category.helpText != '') {
           const span = document.createElement('span');
           span.textContent = category.helpText || ``;
           span.className = 'foodify-disclaim'
           span.style.marginLeft = '15px'
           span.style.fontWeight = 'normal'
           span.style.fontSize = '17px'
           span.style.opacity = '0.7'
           legend.appendChild(span);
        }
        fieldset.appendChild(legend);
        const optionsContainer = document.createElement('div');
        optionsContainer.className = categoryType === 'select' ? 'options form-control': 'options' ;
        optionsContainer.style.display = 'flex';
        optionsContainer.style.flexWrap = 'wrap';
        optionsContainer.style.columnGap = '15px';
        optionsContainer.style.rowGap = '5px';
       
        // console.log(categoryOptions)

        const itemWithSKU = categoryOptions.find(item => item.useSKU);
        if (itemWithSKU) {
        //-console.log(itemWithSKU.sku);
          fieldset.setAttribute('data-sku', itemWithSKU.sku);
        }
       
        ///////////////////////////////////////////////////////////////
        if (categoryType === 'select') {
           ///////////////////////////////////////////////////////////////
           const select = document.createElement('select');
           select.className = 'option select knhjd';
           select.name = `properties[${categoryName}]`;
           select.dataset.use = 'extra-option';
           select.required = category.required == 'true' ? 'true' : 'false';
           select.id = categoryId;
           const placeholderOption = document.createElement('option');
           placeholderOption.textContent = category.selectionMessage || `Please Select ${categoryName}`;
           placeholderOption.value = '';
           placeholderOption.disabled = true;
           placeholderOption.selected = true;
           placeholderOption.dataset.price = '0';
           select.style.marginBottom = "0px";
           select.appendChild(placeholderOption);
           categoryOptions.sort((a, b) => (a.index || Infinity) - (b.index || Infinity)).forEach((option, index) => {
              if (option.type && option.type == 'rule') {} else {
                 const selectOption = document.createElement('option');
                 selectOption.value = option.name;
                 selectOption.id = option.optionId;
                 selectOption.dataset.price = option.cost;
                 selectOption.textContent = option.name;
                 select.appendChild(selectOption);
              }
           });


           const svgElement = document.createElementNS("http://www.w3.org/2000/svg", "svg");
            svgElement.setAttribute("role", "presentation");
            svgElement.setAttribute("focusable", "false");
            svgElement.setAttribute("width", "10");
            svgElement.setAttribute("height", "7");
            svgElement.setAttribute("class", "select-chevron icon icon-chevron-bottom");
            svgElement.setAttribute("viewBox", "0 0 10 7");
            
            const pathElement = document.createElementNS("http://www.w3.org/2000/svg", "path");
            pathElement.setAttribute("d", "m1 1 4 4 4-4");
            pathElement.setAttribute("fill", "none");
            pathElement.setAttribute("stroke", "currentColor");
            pathElement.setAttribute("stroke-width", "2");
            
            svgElement.appendChild(pathElement);
            
            


          
           optionsContainer.appendChild(select);
           optionsContainer.appendChild(svgElement);
           ///////////////////////////////////////////////////////////////
        } 
        else if (categoryType === 'image') {
          ///////////////////////////////////////////////////////////////
          categoryOptions.sort((a, b) => (a.index || Infinity) - (b.index || Infinity)).forEach((option, index) => {
              if (option.type && option.type == 'rule') {} else {
                 const input = document.createElement('input');
                 input.className = `${categoryType} knhjd knhjd-pic`;
                 input.type = 'radio';
                 input.id = option.optionId;
                 input.value = option.name;
                 input.dataset.price = option.cost;
                 input.name = `properties[${categoryName}]`;
                 input.dataset.use = 'extra-option';
                 input.hidden = true;
                 const label = document.createElement('label');
                 label.htmlFor = input.id;
                 label.style.cursor = 'pointer';
                 label.style.display = 'inline-block';
                 label.style.position = 'relative';
                 label.style.marginBottom = '30px';
                 label.dataset.link = option.name;
                 const img = document.createElement('img');
                 img.src = option.imageUrl;
                 img.alt = option.name;
                 img.style.width = '100px';
                 img.style.height = '100px';
                 img.style.objectFit = 'cover';
                 img.style.objectPosition = 'center';
                 label.appendChild(img);
                 const span = document.createElement('span');
                 span.textContent = option.name;
                 span.style.position = 'absolute';
                 span.style.bottom = '-35px';
                 span.style.left = '0px';
                 label.appendChild(span);
                 const optionDiv = document.createElement('div');
                 optionDiv.className = 'option';
                 optionDiv.appendChild(input);
                 optionDiv.appendChild(label);
                 optionsContainer.appendChild(optionDiv);
                 label.addEventListener('click', () => {           
                  if(!input.disabled) {
                     input.checked = true;
                     const customChangeEvent = new Event("change", {
                        bubbles: true,
                     });
                     input.dispatchEvent(customChangeEvent);
                  }               
                 });
                 input.addEventListener('click', function(e) {
                    if (input.getAttribute('data-last-clicked') === 'true') {
                       input.checked = false;
                       input.setAttribute('data-last-clicked', 'false');
                    } else {
                       const radios = document.querySelectorAll(`input[name="${input.name}"]`);
                       radios.forEach(radio => radio.setAttribute('data-last-clicked', 'false'));
                       input.setAttribute('data-last-clicked', 'true');
                    }
                 });
              }
           });
          ///////////////////////////////////////////////////////////////
        } 
        else if (categoryType === 'image-multi') {
           ///////////////////////////////////////////////////////////////
           const hasLimit = category.optionLimit && categoryType === 'image-multi' && category.hasOwnProperty('hardLimitNumber') ? category.hasOwnProperty('hardLimitNumber') != '' : category.hardLimit;
           const inputs = [];
           if (!hasLimit) {}
           categoryOptions.sort((a, b) => (a.index || Infinity) - (b.index || Infinity)).forEach((option, index) => {
              if (option.type && option.type == 'rule') {} else {
                 const input = document.createElement('input');
                 input.className = `${categoryType} knhjd knhjd-pic `;
                 input.type = 'checkbox';
                 input.id = option.optionId;
                 input.value = option.name;
                 input.dataset.price = option.cost;
                 input.name = `properties[${categoryName}-${index + 1}]`;
                 input.dataset.use = 'extra-option';
                 input.hidden = true;
                 const label = document.createElement('label');
                 label.htmlFor = input.id;
                 label.style.cursor = 'pointer';
                 label.style.display = 'inline-block';
                 label.style.position = 'relative';
                 label.style.marginBottom = '30px';
                 label.dataset.link = option.name;
                 const img = document.createElement('img');
                 img.src = option.imageUrl;
                 img.alt = option.name;
                 img.style.width = '100px';
                 img.style.height = '100px';
                 img.style.objectFit = 'cover';
                 img.style.objectPosition = 'center';
                 label.appendChild(img);
                 const span = document.createElement('span');
                 span.textContent = option.name;
                 span.style.position = 'absolute';
                 span.style.bottom = '-35px';
                 span.style.left = '0px';
                 label.appendChild(span);
                 const optionDiv = document.createElement('div');
                 optionDiv.className = 'option';
                 
                 optionDiv.appendChild(input);
                 optionDiv.appendChild(label);
                 optionsContainer.appendChild(optionDiv);
                 label.addEventListener('click', () => {
                    const customChangeEvent = new Event("change", {
                       bubbles: true,
                    });
                    input.dispatchEvent(customChangeEvent);
                 });
                 if (hasLimit) inputs.push(input);
              }
           });
           if (hasLimit) {
              inputs.forEach(input => {
                 input.addEventListener('change', (event) => {
                    let hardLimitNumberValue = parseInt(category.hardLimitNumber);
                    let isHardLimitNumber = !isNaN(hardLimitNumberValue);
                   
                    const checkedInputs = inputs.filter(checkbox => checkbox.checked);
                    if(isHardLimitNumber) {
                      
                      if (checkedInputs.length > category.optionLimit) {
                        inputs.forEach(checkbox => {
                          setTimeout(() => {
                            if (checkbox.getAttribute("data-additionalcost")) {
                              if (!checkbox.checked || checkbox === event.target) {
                                checkbox.setAttribute("data-price", checkbox.getAttribute("data-additionalcost") || checkbox.getAttribute("data-originalcost"));
                              }
                            }
                          }, 150);
                        });
                      } 
                      else if (checkedInputs.length == category.optionLimit) {
                        inputs.forEach(checkbox => {
                          setTimeout(() => {
                            if (checkbox.getAttribute("data-originalcost")) {
                              checkbox.setAttribute("data-price", checkbox.getAttribute("data-originalcost"));
                            }
                          }, 150);
                        });
                      } 
                      else {
                        inputs.forEach(checkbox => {
                          setTimeout(() => {
                            if (checkbox.getAttribute("data-originalcost")) {
                              checkbox.setAttribute("data-price", checkbox.getAttribute("data-originalcost"));
                            }
                          }, 150);
                        });
                      } 
                      
                    } 
                    else {
                      if (checkedInputs.length >= category.optionLimit) {
                         inputs.forEach(checkbox => {
                            if (!checkbox.checked) checkbox.disabled = true;
                         });
                      } 
                      else {
                         inputs.forEach(checkbox => {
                            checkbox.disabled = false;
                         });
                      }
                    }
                   
                 });
              });
           }
           ///////////////////////////////////////////////////////////////
        } 
        else if (categoryType === 'pill') {
           ///////////////////////////////////////////////////////////////
           const inputs = [];
           categoryOptions.sort((a, b) => (a.index || Infinity) - (b.index || Infinity)).forEach((option, index) => {
             
              if (option.type && option.type == 'rule') {} 
              else {
                 const input = document.createElement('input');
                 input.className = `${categoryType} knhjd`;
                 input.type = 'radio';
                 input.id = option.optionId;
                 input.value = option.name;
                 input.dataset.price = option.cost;
                 input.name = categoryType === 'pill' ? `properties[${categoryName}]` : `properties[${categoryName}-${index + 1}]`;
                 input.dataset.use = 'extra-option';
                 if(category.required)  input.required =  'true';
                 const label = document.createElement('label');
                 label.className = `pill`
                 label.setAttribute('for', input.id);
                 label.style.paddingInlineStart = '5px';
                 label.style.color = 'rgb(var(--text-color))';
                 label.textContent = option.name;
                 label.dataset.link = option.name;
                 const optionDiv = document.createElement('div');
                 optionDiv.className = 'option';
                 
                 optionDiv.appendChild(input);
                 optionDiv.appendChild(label);
                 optionsContainer.appendChild(optionDiv);
                 if (categoryType === 'pill') {
                    label.addEventListener('click', function(e) {
                       e.stopPropagation()
                       if (input.getAttribute('data-last-clicked') === 'true') {
                          const changeEvent = new Event('change', {
                             bubbles: true,
                             cancelable: true
                          });
                          input.dispatchEvent(changeEvent);
                          input.checked = false;
                          input.setAttribute('data-last-clicked', 'false');
                       } else {
                          input.checked = true;
                          const radios = document.querySelectorAll(`input[name="${input.name}"]`);
                          radios.forEach(radio => radio.setAttribute('data-last-clicked', 'false'));
                          input.setAttribute('data-last-clicked', 'true');
                       }
                    });
                 }
               }

           });
           ///////////////////////////////////////////////////////////////
        }
        else if (categoryType === 'pill-multi')  {
         ///////////////////////////////////////////////////////////////
         const hasLimit = category.optionLimit && categoryType === 'checkbox' && category.hasOwnProperty('hardLimitNumber') ? category.hasOwnProperty('hardLimitNumber') != '' : category.hardLimit;
         const inputs = [];
         if (!hasLimit) {}
         categoryOptions.sort((a, b) => (a.index || Infinity) - (b.index || Infinity)).forEach((option, index) => {
            if (option.type && option.type == 'rule') {} 
            else {
               const input = document.createElement('input');
               input.className = `pill knhjd`;
               input.type = 'checkbox';
               input.id = option.optionId;
               input.value = option.name;
               input.dataset.price = option.cost;
               input.dataset.originalcost = option.cost;
               input.dataset.additionalcost = option.additionalCost;
               input.name = `properties[${categoryName}-${index + 1}]`;
               input.dataset.use = 'extra-option';
               const label = document.createElement('label');
               label.className = `pill`
               label.setAttribute('for', input.id);
               label.style.paddingInlineStart = '5px';
               label.style.color = 'rgb(var(--text-color))';
               label.textContent = option.name;
               label.dataset.link = option.name;
               const optionDiv = document.createElement('div');
               optionDiv.className = 'option';

               label.addEventListener('click', function(event) {
                   event.preventDefault();
                   event.stopPropagation();
                   let input = this.closest('div').querySelector('input[type="checkbox"], input[type="radio"]');
                   if (input) {
                     if(!input.disabled){
                      input.checked = !input.checked;
                      const changeEvent = new Event('change', {
                           bubbles: true,
                           cancelable: true
                        });
                        input.dispatchEvent(changeEvent);
                      }
                     }
                });
                
               optionDiv.appendChild(input);
               optionDiv.appendChild(label);
               optionsContainer.appendChild(optionDiv);
               if (hasLimit) inputs.push(input);
            }
         });
         if (hasLimit) {
            inputs.forEach(input => {
               input.addEventListener('change', (event) => {
                  let hardLimitNumberValue = parseInt(category.hardLimitNumber);
                  let isHardLimitNumber = !isNaN(hardLimitNumberValue);
                 
                  const checkedInputs = inputs.filter(checkbox => checkbox.checked);

                  if(isHardLimitNumber) {
                    
                    if (checkedInputs.length >= hardLimitNumberValue) {
                       inputs.forEach(checkbox => {
                          if (!checkbox.checked) checkbox.disabled = true;
                       });
                    } 
                    else {
                       inputs.forEach(checkbox => {
                          checkbox.disabled = false;
                       });
                    }

                    if (checkedInputs.length > category.optionLimit) {
                      inputs.forEach(checkbox => {
                        setTimeout(() => {
                          if (checkbox.getAttribute("data-additionalcost")) {
                            if (!checkbox.checked || checkbox === event.target) {
                              checkbox.setAttribute("data-price", checkbox.getAttribute("data-additionalcost") || checkbox.getAttribute("data-originalcost"));
                            }
                          }
                        }, 150);
                      });
                    } 
                    else if (checkedInputs.length == category.optionLimit) {
                      inputs.forEach(checkbox => {
                        setTimeout(() => {
                          if (checkbox.getAttribute("data-originalcost")) {
                            checkbox.setAttribute("data-price", checkbox.getAttribute("data-originalcost"));
                          }
                        }, 150);
                      });
                    } 
                    else {
                      inputs.forEach(checkbox => {
                        setTimeout(() => {
                          if (checkbox.getAttribute("data-originalcost")) {
                            checkbox.setAttribute("data-price", checkbox.getAttribute("data-originalcost"));
                          }
                        }, 150);
                      });
                    } 
                    
                  } 
                  else {
                    if (checkedInputs.length >= category.optionLimit) {
                       inputs.forEach(checkbox => {
                          if (!checkbox.checked) checkbox.disabled = true;
                       });
                    } 
                    else {
                       inputs.forEach(checkbox => {
                          checkbox.disabled = false;
                       });
                    }
                  }
                  
               });
            });
         }
         ///////////////////////////////////////////////////////////////
         }
        else {
           ///////////////////////////////////////////////////////////////
           const hasLimit = category.optionLimit && categoryType === 'checkbox' && category.hasOwnProperty('hardLimitNumber') ? category.hasOwnProperty('hardLimitNumber') != '' : category.hardLimit;
           const inputs = [];
           if (!hasLimit) {}
           categoryOptions.sort((a, b) => (a.index || Infinity) - (b.index || Infinity)).forEach((option, index) => {
              if (option.type && option.type == 'rule') {} 
              else {
                 const input = document.createElement('input');
                 input.className = `${categoryType} knhjd`;
                 input.type = categoryType;
                 input.id = option.optionId;
                 input.value = option.name;
                 input.dataset.price = option.cost;
                 input.dataset.originalcost = option.cost;
                 input.dataset.additionalcost = option.additionalCost;
                 input.name = categoryType === 'radio' ? `properties[${categoryName}]` : `properties[${categoryName}-${index + 1}]`;
                 input.dataset.use = 'extra-option';
                 const label = document.createElement('label');
                 label.setAttribute('for', input.id);
                 label.style.paddingInlineStart = '5px';
                 label.style.color = 'rgb(var(--text-color))';
                 label.textContent = option.name;
                 label.dataset.link = option.name;
                 const optionDiv = document.createElement('div');
                 optionDiv.className = 'option';

                 if(categoryType === 'checkbox'){
                  label.addEventListener('click', (event) => {
                     if (!input.disabled) {
                       input.checked = !input.checked;
                       const clickEvent = new Event('change', { bubbles: true });
                       input.dispatchEvent(clickEvent);
                     }
                     event.preventDefault();
                    });
                 }
                 
                 optionDiv.appendChild(input);
                 optionDiv.appendChild(label);
                 optionsContainer.appendChild(optionDiv);
                 if(category.required && categoryType === 'radio') input.required = 'true';
                 if (categoryType === 'radio' && forMultiple) {
                  
                  const handleInputClick = function(e) {
                      e.stopPropagation();
                      if (input.getAttribute('data-last-clicked') === 'true') {
                          const changeEvent = new Event('change', {
                              bubbles: true,
                              cancelable: true
                          });
                          input.dispatchEvent(changeEvent);
                          input.checked = false;
                          input.setAttribute('data-last-clicked', 'false');
                      } else {
                          input.checked = true;
                          const radios = document.querySelectorAll(`input[name="${input.name}"]`);
                          radios.forEach(radio => radio.setAttribute('data-last-clicked', 'false'));
                          input.setAttribute('data-last-clicked', 'true');
                      }
                  };
              
                  input.addEventListener('click', handleInputClick);
                  label.addEventListener('click', handleInputClick);
                 }
                 if (hasLimit) inputs.push(input);
              }
           });
           if (hasLimit) {
              inputs.forEach(input => {
                 input.addEventListener('change', (event) => {
                    let hardLimitNumberValue = parseInt(category.hardLimitNumber);
                    let isHardLimitNumber = !isNaN(hardLimitNumberValue);
                   
                    const checkedInputs = inputs.filter(checkbox => checkbox.checked);
 
                    if(isHardLimitNumber) {
                      
                      if (checkedInputs.length >= hardLimitNumberValue) {
                         inputs.forEach(checkbox => {
                            if (!checkbox.checked) checkbox.disabled = true;
                         });
                      } 
                      else {
                         inputs.forEach(checkbox => {
                            checkbox.disabled = false;
                         });
                      }

                      if (checkedInputs.length > category.optionLimit) {
                        inputs.forEach(checkbox => {
                          setTimeout(() => {
                            if (checkbox.getAttribute("data-additionalcost")) {
                              if (!checkbox.checked || checkbox === event.target) {
                                checkbox.setAttribute("data-price", checkbox.getAttribute("data-additionalcost") || checkbox.getAttribute("data-originalcost"));
                              }
                            }
                          }, 150);
                        });
                      } 
                      else if (checkedInputs.length == category.optionLimit) {
                        inputs.forEach(checkbox => {
                          setTimeout(() => {
                            if (checkbox.getAttribute("data-originalcost")) {
                              checkbox.setAttribute("data-price", checkbox.getAttribute("data-originalcost"));
                            }
                          }, 150);
                        });
                      } 
                      else {
                        inputs.forEach(checkbox => {
                          setTimeout(() => {
                            if (checkbox.getAttribute("data-originalcost")) {
                              checkbox.setAttribute("data-price", checkbox.getAttribute("data-originalcost"));
                            }
                          }, 150);
                        });
                      } 
                      
                    } 
                    else {
                      if (checkedInputs.length >= category.optionLimit) {
                         inputs.forEach(checkbox => {
                            if (!checkbox.checked) checkbox.disabled = true;
                         });
                      } 
                      else {
                         inputs.forEach(checkbox => {
                            checkbox.disabled = false;
                         });
                      }
                    }
                    
                 });
              });
           }
           ///////////////////////////////////////////////////////////////
        }
        ///////////////////////////////////////////////////////////////


       setTimeout(()=> {
          // document.querySelectorAll('.variant-options-area .option label').forEach(label => {
          //           console.log(label)
          //             label.addEventListener('click', event => {
          //                 const input = document.getElementById(label.getAttribute('for'));
          //                 if (input) {
          //                     input.checked = true;
          //                     const clickEvent = new Event('click', { bubbles: true });
          //                     input.dispatchEvent(clickEvent);
          //                   console.log(`Label clicked: ${label.getAttribute('for')}`);
          //                 }
          //             });
          //         });
       },'150')
         
       
        fieldset.appendChild(optionsContainer);
        fieldset.appendChild(document.createElement('br'));
        productOptionsContainer.appendChild(fieldset);
      


/*       
// Check if there is a limit on the number of options that can be selected and if the category type is 'checkbox'
if (category.optionLimit && category.optionLimit != 0 && categoryType === 'checkbox') {
  // Select all checkbox elements within the fieldset
  const checkboxes = fieldset.querySelectorAll('.checkbox');
  
  // Define a function to update the selection count
  const updateSelectionCount = () => {
    // Count the number of checkboxes that are currently checked
    const selectedCount = Array.from(checkboxes).filter(checkbox => checkbox.checked).length;
    
    // Check if the number of selected checkboxes exceeds the limit
    if (Number(selectedCount) > Number(category.optionLimit)) {
      // Iterate over the category options and update the price attribute
      categoryOptions.forEach((option, index) => {
        if (index < Number(category.optionLimit)) {
          // Set the price attribute to 0 for options within the limit
          checkboxes[index].setAttribute('data-price', 0);
        } else {
          // Set the price attribute to the additional cost for options outside the limit, if the checkbox exists
          if(checkboxes[index]){
            checkboxes[index].setAttribute('data-price', option.additionalCost || 0);
          }
        }
      });
    } else {
      // If the number of selections does not exceed the limit, set the price attribute of all options to 0
      categoryOptions.forEach((option, index) => {
        if(checkboxes[index]){
          checkboxes[index].setAttribute('data-price', 0);
        }
      });
    }
  };
  // Add a 'change' event listener to each checkbox to update the selection count whenever any checkbox is toggled
  checkboxes.forEach(checkbox => checkbox.addEventListener('change', updateSelectionCount));
}

        */  



       
     });

     let uniqueSelector = itemSelector != '' ? `.modal#modal-${itemSelector} ` : '';

    //insert
     if(!forMultiple){
       let insertOptions = document.querySelector('form[method="post"][data-type="add-to-cart-form"][is="product-form"]')
       if (insertOptions) {
         document.querySelectorAll('form[is="product-form"] .foodify-options-loading, #product-options-wrapper .foodify-options-loading').forEach((n) => n.remove());
         productOptionsContainer.style.display = 'none';
         setTimeout(() => {
             insertOptions.prepend(productOptionsContainer);
             productOptionsContainer.style.display = 'block';
          }, 50);
         foodifyInitialize(storeData)
       }
     }
     else {
       let insertOptions = document.querySelector(`${uniqueSelector}  main .options-foodify-container`)
       // console.log(uniqueSelector)
       if (insertOptions) {
          insertOptions.querySelectorAll('.foodify-options-loading').forEach((n) => n.remove());
          insertOptions.prepend(productOptionsContainer);
         foodifyInitialize(storeData, forMultiple, uniqueSelector, singleProductData)
       }
     }

     if(!forMultiple){
      waitForElmFoodify(`#product-options fieldset`).then(() => {
       //-console.log("window on load")
         timer.stop('INSERT');
         Object.keys(optionsData.options).forEach(categoryName => {
            const category = optionsData.options[categoryName];
            let categoryOptions = category.items;
            categoryOptions.forEach(option => {
               if (option.type && option.type === 'rule') {
                  let { action, ruleFields, conditionLink, firstCondition, secondCondition, ruleId } = option;
                  const addEventListenersForOption = (option, categoryType, optionLimit) => {
                     const generateRuleWithOption = (event) => generateRule(uniqueSelector, categoryName, option, categoryType, optionLimit ? optionLimit : 0, event);
                     waitForElmFoodify(`${uniqueSelector} #product-options .product-option select`).then(() => {
                        const selects = document.querySelectorAll(`${uniqueSelector} #product-options select`);
                        selects.forEach((select) => select.addEventListener("change", generateRuleWithOption));
                     });
                     
                     // Trigger variant change when foodify select options change to update data-variant-price
                     waitForElmFoodify(`${uniqueSelector} #product-options .product-option select`).then(() => {
                        const selects = document.querySelectorAll(`${uniqueSelector} #product-options select`);
                        selects.forEach((select) => select.addEventListener("change", () => {
                           // Trigger variant change to update data-variant-price
                           const variantSelects = document.querySelectorAll('variant-selects');
                           variantSelects.forEach(variantSelect => {
                              if (variantSelect.onVariantChange) {
                                 variantSelect.onVariantChange();
                              }
                           });
                        }));
                     });
                     waitForElmFoodify(`${uniqueSelector}  #product-options .product-option input[type="checkbox"]`).then(() => {
                        const checkboxes = document.querySelectorAll(`${uniqueSelector} #product-options input[type='checkbox']`);
                        checkboxes.forEach((checkbox) => checkbox.addEventListener("change", generateRuleWithOption));
                     });
                     waitForElmFoodify(`${uniqueSelector}  #product-options .product-option input[type="radio"]`).then(() => {
                        const radioboxes = document.querySelectorAll(`${uniqueSelector} #product-options input[type='radio']`);
                        radioboxes.forEach((radiobox) => radiobox.addEventListener("change", generateRuleWithOption));
                     });
                     
                     // Trigger variant change when foodify options change to update data-variant-price
                     waitForElmFoodify(`${uniqueSelector} #product-options .product-option input[type="checkbox"]`).then(() => {
                        const checkboxes = document.querySelectorAll(`${uniqueSelector} #product-options input[type='checkbox']`);
                        checkboxes.forEach((checkbox) => checkbox.addEventListener("change", () => {
                           // Trigger variant change to update data-variant-price
                           const variantSelects = document.querySelectorAll('variant-selects');
                           variantSelects.forEach(variantSelect => {
                              if (variantSelect.onVariantChange) {
                                 variantSelect.onVariantChange();
                              }
                           });
                        }));
                     });
                     
                     waitForElmFoodify(`${uniqueSelector} #product-options .product-option input[type="radio"]`).then(() => {
                        const radioboxes = document.querySelectorAll(`${uniqueSelector} #product-options input[type='radio']`);
                        radioboxes.forEach((radiobox) => radiobox.addEventListener("change", () => {
                           // Trigger variant change to update data-variant-price
                           const variantSelects = document.querySelectorAll('variant-selects');
                           variantSelects.forEach(variantSelect => {
                              if (variantSelect.onVariantChange) {
                                 variantSelect.onVariantChange();
                              }
                           });
                        }));
                     });


                    
                      
                       ////////// For Native Variants //////////////////////
                     //-console.log("sok", uniqueSelector)
                       waitForElmFoodify(`${uniqueSelector} variant-radios input[type="radio"].native-variant`).then((elm) => {
                       //-console.log("sko222k", elm)
                       //-console.log(`${uniqueSelector} variant-radios input[type="radio"].native-variant`)
                          const radioboxes = document.querySelectorAll(`${uniqueSelector} variant-radios input[type='radio'].native-variant`);
                        //-console.log(":RAdios")
                        //-console.log(radioboxes)
                         
                           radioboxes.forEach((radiobox) => {
                             radiobox.addEventListener("change", (event) => {
                              updateBasePrice(event, radiobox); 
                              // console.log("changer--------------")
                              generateRuleWithOption(event);
                              
                            });
                           })
                          
                       });
                       function updateBasePrice(event, radiobox) {
                        console.log("update", radiobox)
                         
                          var productOptions = document.querySelector('#product-options');
                        //-console.log(productOptions)
                          if (productOptions) {
                            // console.log("enter--------")
                          console.log(radiobox.getAttribute('data-variant-price'))
                            if(radiobox.getAttribute('data-variant-price')){
                              productOptions.setAttribute('data-base', radiobox.getAttribute('data-variant-price'));
                            }
                            
                          }

                        }
                       ////////// End For Native Variants //////////////////


 
                  };
         
                  addEventListenersForOption(option, category.type, category.optionLimit);
               }
            });


           
         });
         dispatchFirstInputChange(uniqueSelector)
     });
    }
     else {
      setTimeout(() => {
           Object.keys(optionsData.options).forEach(categoryName => {
              const category = optionsData.options[categoryName];
              let categoryOptions = category.items;
              categoryOptions.forEach(option => {
                 if (option.type && option.type === 'rule') {
                    let { action, ruleFields, conditionLink, firstCondition, secondCondition, ruleId } = option;
                    const addEventListenersForOption = (option, categoryType, optionLimit) => {
                       const generateRuleWithOption = (event) => generateRule(uniqueSelector, categoryName, option, categoryType, optionLimit ? optionLimit : 0, event);
                       waitForElmFoodify(`${uniqueSelector} #product-options .product-option select`).then(() => {
                          const selects = document.querySelectorAll(`${uniqueSelector} #product-options select`);
                          selects.forEach((select) => select.addEventListener("change", generateRuleWithOption));
                       });
                       waitForElmFoodify(`${uniqueSelector}  #product-options .product-option input[type="checkbox"]`).then(() => {
                          const checkboxes = document.querySelectorAll(`${uniqueSelector} #product-options input[type='checkbox']`);
                          checkboxes.forEach((checkbox) => checkbox.addEventListener("change", generateRuleWithOption));
                       });
                       waitForElmFoodify(`${uniqueSelector}  #product-options .product-option input[type="radio"]`).then(() => {
                          const radioboxes = document.querySelectorAll(`${uniqueSelector} #product-options input[type='radio']`);
                          radioboxes.forEach((radiobox) => radiobox.addEventListener("change", generateRuleWithOption));
                       });


                    };
                    addEventListenersForOption(option, category.type, category.optionLimit);
                 }
                // sssss
                   
                 ////////// For Native Variants //////////////////////variant-options-area //
                 waitForElmFoodify(`${uniqueSelector} variant-radios  input[type="radio"].native-variant`).then((elm) => {

                    const radioboxes = document.querySelectorAll(`${uniqueSelector} variant-radios  input[type='radio'].native-variant`);
     
                     radioboxes.forEach((radiobox) => {
                       radiobox.addEventListener("change", (event) => {
                        updateBasePrice(event, radiobox, uniqueSelector); 
                        // console.log("changer--------------")
                        // generateRuleWithOption(event);
                        
                      });
                     })
                    
                 });
                 function updateBasePrice(event, radiobox, uniqueSelector) {
                  // console.log("update", radiobox)
                   
                    var productOptions = document.querySelector(`${uniqueSelector} #product-options`);
           
                    if (productOptions) {
                    //   console.log(productOptions)
                    // console.log(radiobox.getAttribute('data-variant-price'))
                      if(radiobox.getAttribute('data-variant-price')){
                        productOptions.setAttribute('data-base', radiobox.getAttribute('data-variant-price'));
                        setTimeout(() => {
                            updateOptionsPrice(uniqueSelector);
                         }, 200);
                      }
                    }

                  }
                 ////////// End For Native Variants //////////////////

                
              });
           });
           dispatchFirstInputChange(uniqueSelector)
      }, '500')
    }


   waitForElmFoodify(`${uniqueSelector} variant-radios input[type="radio"].native-variant:checked`).then((radiobox) => {
    setTimeout(() => {
        updateBasePrice(radiobox, uniqueSelector);
    }, 1000);

    function updateBasePrice(radiobox, uniqueSelector) {
        var productOptions = document.querySelector(`${uniqueSelector} #product-options`);
        if (productOptions && radiobox.getAttribute('data-variant-price')) {
            productOptions.setAttribute('data-base', radiobox.getAttribute('data-variant-price'));
            updateOptionsPrice(uniqueSelector);
          }
        }
    });



////////// For Native Variants //////////////////////
waitForElmFoodify(`${uniqueSelector} variant-radios input[type="radio"].native-variant`).then(() => {
   document.querySelectorAll(`${uniqueSelector} variant-radios input[type="radio"].native-variant`).forEach(radiobox => {
     radiobox.addEventListener("change", event => {
       const productOptions = document.querySelector('#product-options');
       if (productOptions && radiobox.getAttribute('data-variant-price')) {
         productOptions.setAttribute('data-base', radiobox.getAttribute('data-variant-price'));
       }
     });
   });
 });

 // Listen for changes to data-variant-price on sale-price elements
 waitForElmFoodify(`${uniqueSelector} sale-price[data-variant-price]`).then(() => {
   const observer = new MutationObserver((mutations) => {
     mutations.forEach((mutation) => {
       if (mutation.type === 'attributes' && mutation.attributeName === 'data-variant-price') {
         const salePriceElement = mutation.target;
         const newPrice = salePriceElement.getAttribute('data-variant-price');
         const productOptions = document.querySelector(`${uniqueSelector} #product-options`);
         if (productOptions && newPrice) {
           productOptions.setAttribute('data-base', newPrice);
           // Trigger price update
           setTimeout(() => {
             updateOptionsPrice(uniqueSelector);
           }, 100);
         }
       }
     });
   });

   // Observe all sale-price elements for data-variant-price changes
   document.querySelectorAll(`${uniqueSelector} sale-price[data-variant-price]`).forEach(element => {
     observer.observe(element, { attributes: true, attributeFilter: ['data-variant-price'] });
   });
 });
 ////////// End For Native Variants //////////////////




   
     ///////////////////////////////////////////////////////////////
  }

  function fillModal(lineItem, lineItemProperties, lineItemModal) {
    ///////////////////////////////////////////////////////////////
    const properties = lineItemProperties.split('^^^').reduce((acc, cur) => {
        const [key, value] = cur.split(':::');
        const baseKey = key.split('-')[0]; // Extract base key without numeric suffix
        if (key.includes('-')) {
          // If the key includes a '-', it's part of a series (e.g., Sandwich Toppings)
          acc[baseKey] = acc[baseKey] || []; // Initialize as array if not already
          acc[baseKey].push(value);
        } else {
          acc[baseKey] = value;
        }
        return acc;
      }, {});
    Object.entries(properties).forEach(([key, value]) => {
      if(lineItemModal) {
   
        const fieldset = lineItemModal.querySelector(`fieldset[data-id="${key.toLowerCase().replace(" ", "-")}"]`);
        if (!fieldset) return;
      
        if (Array.isArray(value)) {
          value.forEach(val => {
            const normalizedVal = val.trim().toLowerCase();
            const checkboxes = Array.from(fieldset.querySelectorAll('input[type="checkbox"]'));
            const checkbox = checkboxes.find(checkbox => checkbox.value.trim().toLowerCase() === normalizedVal);
            if (checkbox) checkbox.checked = true;
          });
        } 
        else {
          const input = fieldset.querySelector('input, select');
          if (input.tagName.toLowerCase() === 'select') {
            const normalizedValue = value.trim().toLowerCase();
            const options = Array.from(input.options);
            const matchingOption = options.find(option => option.value.trim().toLowerCase() === normalizedValue);
            if (matchingOption) input.value = matchingOption.value;
          } 
          else if (input.type.toLowerCase() === 'checkbox') {
            input.checked = true;
          }
        }
           
      }
    });
    ///////////////////////////////////////////////////////////////
  }

  const formatMoneyFoodify = (cents, format = "") => {
    ///////////////////////////////////////////////////////////////
    if (typeof cents === "string") {
       cents = cents.replace(".", "");
    }
    const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/, formatString = format || window.themeVariables.settings.moneyFormat;
    function defaultTo(value2, defaultValue) {
       return value2 == null || value2 !== value2 ? defaultValue : value2;
    }
    function formatWithDelimiters(number, precision, thousands, decimal) {
       precision = defaultTo(precision, 2);
       thousands = defaultTo(thousands, ",");
       decimal = defaultTo(decimal, ".");
       if (isNaN(number) || number == null) {
          return 0;
       }
       number = (number / 100).toFixed(precision);
       let parts = number.split("."),
          dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands),
          centsAmount = parts[1] ? decimal + parts[1] : "";
       return dollarsAmount + centsAmount;
    }
    let value = "";
    switch (formatString.match(placeholderRegex)[1]) {
       case "amount":
          value = formatWithDelimiters(cents, 2);
          break;
       case "amount_no_decimals":
          value = formatWithDelimiters(cents, 0);
          break;
       case "amount_with_space_separator":
          value = formatWithDelimiters(cents, 2, " ", ".");
          break;
       case "amount_with_comma_separator":
          value = formatWithDelimiters(cents, 2, ".", ",");
          break;
       case "amount_with_apostrophe_separator":
          value = formatWithDelimiters(cents, 2, "'", ".");
          break;
       case "amount_no_decimals_with_comma_separator":
          value = formatWithDelimiters(cents, 0, ".", ",");
          break;
       case "amount_no_decimals_with_space_separator":
          value = formatWithDelimiters(cents, 0, " ");
          break;
       case "amount_no_decimals_with_apostrophe_separator":
          value = formatWithDelimiters(cents, 0, "'");
          break;
       default:
          value = formatWithDelimiters(cents, 2);
          break;
    }
    if (formatString.indexOf("with_comma_separator") !== -1) {
       return formatString.replace(placeholderRegex, value);
    } 
    else {
       return formatString.replace(placeholderRegex, value);
    }
    ///////////////////////////////////////////////////////////////
  }

  const getExtraCost = (uniqueSelector) => {
    ///////////////////////////////////////////////////////////////
    let selectTotalPrice = 0;
    let inputTotalPrice = 0;
    const fieldsets = document.querySelectorAll(`${uniqueSelector} #product-options fieldset.foodify-fieldset`);
    fieldsets.forEach((fieldset, index) => {
       if (fieldset.dataset.notIncluded == true || fieldset.dataset.notIncluded == 'true') {
          // console.log("skipping extra cost for - ", fieldset)
       } 
       else {
          const selectElements = fieldset.querySelectorAll('#product-options fieldset select.knhjd[data-use="extra-option"]');

          selectElements.forEach((selectElement, index) => {
             if (selectElement.dataset.notIncluded == true || selectElement.dataset.notIncluded == 'true') {
                // console.log("skipping extra cost for - ", selectElement)
             } else {
                const selectedOption = selectElement.options[selectElement.selectedIndex];
                // console.error(selectElement, index)
                const dataPriceString = selectedOption ? selectedOption.getAttribute('data-price')  : '0';
                const dataPrice = parseFloat(dataPriceString);
                if (!isNaN(dataPrice)) {
                   selectTotalPrice += dataPrice;
                } else {
                   console.error(`Invalid data-price value for select ${index + 1}`);
                   return;
                }
             }
          });
          const checkboxElements = fieldset.querySelectorAll('#product-options fieldset input.knhjd[data-use="extra-option"]');
          checkboxElements.forEach((checkboxElement, index) => {
             if (checkboxElement.dataset.notIncluded == true || checkboxElement.dataset.notIncluded == 'true') {
                // console.log("skipping extra cost for - ", checkboxElement)
             } else {
                if (checkboxElement.checked) {
                  // console.log(checkboxElement)
                   const dataPriceString = checkboxElement.getAttribute('data-price');
                   const dataPrice = parseFloat(dataPriceString);
                  // console.log(dataPriceString)

                   if (!isNaN(dataPrice)) {
                      inputTotalPrice += dataPrice;
                   } else {
                      console.error(`Invalid data-price value for selected checkbox ${index + 1}`);
                      return;
                   }
                }
             }
          });
       }
    });
    return selectTotalPrice + inputTotalPrice;
    ///////////////////////////////////////////////////////////////
  }
  
  const getPrice = (uniqueSelector) => {
    ///////////////////////////////////////////////////////////////
    try{
    // First, try to get the current variant price from sale-price elements
    const salePriceElement = document.querySelector(`${uniqueSelector} sale-price[data-variant-price]`);
    let currentVariantPrice = null;
    
    if (salePriceElement && salePriceElement.getAttribute('data-variant-price')) {
      currentVariantPrice = salePriceElement.getAttribute('data-variant-price');
    } else {
      // Fallback to radio button variant price
      const selectedVariant = document.querySelector(`${uniqueSelector} variant-radios input[type="radio"].native-variant:checked`);
      if (selectedVariant && selectedVariant.getAttribute('data-variant-price')) {
        currentVariantPrice = selectedVariant.getAttribute('data-variant-price');
      }
    }
    
    // Update the base price if we found a current variant price
    if (currentVariantPrice) {
      const productOptionsElement = document.querySelector(`${uniqueSelector} #product-options`);
      if (productOptionsElement) {
        productOptionsElement.setAttribute('data-base', currentVariantPrice);
      }
    }
    
    const productOptionsElement = document.querySelector(`${uniqueSelector} #product-options`);
    const dataBaseString = productOptionsElement.getAttribute('data-base') || '0';
    const productPrice = parseFloat(dataBaseString);
    if (!isNaN(productPrice)) {
       return productPrice + getExtraCost(uniqueSelector);
    } 
    else {
       console.error('Invalid price value');
    }
    }catch(err){}
    ///////////////////////////////////////////////////////////////
  }

  const updateOptionsPrice = (uniqueSelector) => {
    // return
    setTimeout(()=> {
    const salePrice = document.querySelector('sale-price[form]');
    if (salePrice) {
       salePrice.style.opacity = '0';
       setTimeout(() => {
          salePrice.style.opacity = '1';
       }, 250);
    }
    ///////////////////////////////////////////////////////////////
    const price = formatMoneyFoodify(getPrice(uniqueSelector) * 100, currencyFormat || "{{amount}}");
    // console.log(price, uniqueSelector)
    const priceElement = document.querySelector(`${uniqueSelector} .product product-info .product-info__price price-list sale-price`);
    if (priceElement) {priceElement.innerHTML = `<span class="sr-only">Sale price</span>${price}`;}
    const priceElement2 = document.querySelector(`${uniqueSelector} price-list sale-price`);
    if (priceElement2) {priceElement2.innerHTML = `<span class="sr-only">Sale price</span>${price}`;}
    const priceElementCart = document.querySelector(`${uniqueSelector} .modal__content price-list sale-price`);
    if (priceElementCart) {priceElementCart.innerHTML = `<span class="sr-only">Sale price</span>${price}`;}
    ///////////////////////////////////////////////////////////////
    }, '100')
  }
  
  const resetInputValues = (targetElement, event) => {
    ///////////////////////////////////////////////////////////////
    const inputs = targetElement.querySelectorAll('[data-not-included="true"] input, [data-not-included="true"] select');
    inputs.forEach(input => {
         if (input.type === 'checkbox' || input.type === 'radio') {
            if (input.checked == true) {

               if (input.type == "radio") {
                  input.checked = false;
                  const customData = {
                     exit: true
                  };
                  const customChangeEvent = new CustomEvent("change", {
                     bubbles: true,
                     detail: customData
                  });
                  input.dispatchEvent(customChangeEvent);
                  input.dispatchEvent(customChangeEvent);

               } else {
                  input.checked = false;
               }

            }
            input.checked = false;

         } 
         else if (input.tagName.toLowerCase() === 'select') {
            input.selectedIndex = 0;
         }
         else {
            input.value = '';
         }
      }); 
    ///////////////////////////////////////////////////////////////
  }
  
  const generateRule = (uniqueSelector, categoryName, rule, type, limit, event) => {
     // console.log("-----------------------------------------")
     // console.log("generate rule"); console.log(rule); console.log(uniqueSelector, categoryName, rule, type, limit, event);
     // console.log("-----------------------------------------")
     
     let { action, ruleFields, conditionLink, firstCondition, secondCondition, ruleId } = rule;
     let conditionMet = false;
     const category = ruleId.split("_")[1];
     if (Array.isArray(secondCondition)) {
        // NEW FORMAT FOR MULTI VALUE SECOND CONDITION
        //-console.log("NEW FORMAT")
        if (ruleFields) {
           ///////////////////////////////////////////////////////////////
           if (firstCondition != 'limit' && firstCondition != 'total-selected' && !secondCondition.includes('total-selected') && !secondCondition.includes('limit')) {
              ///////////////////////////////////////////////////////////////
              if (type == 'checkbox' || type == 'image-multi') {
                 waitForElmFoodify(`${uniqueSelector} .foodify-fieldset[data-type="${categoryName.toLowerCase().split(" ").join("-")}"]`).then((elm) => {
                    const fieldset = document.querySelector(`${uniqueSelector} .foodify-fieldset[data-type="${categoryName.toLowerCase().split(" ").join("-")}"]`);
                    setTimeout(() => {}, 1000);
                    const inputs = fieldset.querySelectorAll(`input[type="checkbox"][name^="properties[${category}"]`);
                    const checkedValues = Array.from(inputs).filter(input => input.checked).map(input => input.value);
                    const modifiedSecondCondition = secondCondition.map(item => item.replace('-native-variant', ''));
                    const isSelected = modifiedSecondCondition.some(condition => checkedValues.includes(condition));
                    if (isSelected) {
                       //////////////////////////////////////////////////////////////////
                       ruleFields.forEach(field => {
                          const hasCategory = field.name.includes(" - Category");
                          const target = hasCategory ? field.name.split(" - Category")[0] : field.name;
                          const targetSelector = hasCategory ? `${uniqueSelector} .foodify-fieldset[data-type="${target.toLowerCase().split(" ").join("-")}"]` : `${uniqueSelector} .foodify-fieldset input[value="${field.name}"]`;
                          const targetElement = document.querySelector(targetSelector);
                          if (hasCategory) {
                             const targetFieldset = targetElement;
                             targetFieldset.style.display = action == 'show' ? 'block' : 'none';
                             targetFieldset.dataset.notIncluded = action == 'show' ? false : true;
                             if (action != 'show') {
                                resetInputValues(targetFieldset);
                             }
                          }
                          else {
                             const targetItemInput = targetElement;
                             const targetItemParent = targetItemInput.parentNode;
                             targetItemParent.style.display = action == 'show' ? 'block' : 'none';
                             targetItemInput.dataset.notIncluded = action == 'show' ? false : true;
                             targetItemInput.checked = false;
                             const customChangeEvent = new Event("change", {
                                bubbles: true,
                             });
                          }
                       });
                       //////////////////////////////////////////////////////////////////
                    }
                    else {
                       ///////////////////////////////////////////////////////////////
                       ruleFields.forEach(field => {
                          const hasCategory = field.name.includes(" - Category");
                          const target = hasCategory ? field.name.split(" - Category")[0] : field.name;
                          const targetSelector = hasCategory ? `${uniqueSelector} .foodify-fieldset[data-type="${target.toLowerCase().split(" ").join("-")}"]` : `${uniqueSelector} .foodify-fieldset input[value="${field.name}"]`;
                          const targetElement = document.querySelector(targetSelector);
                          if (hasCategory) {
                             const targetFieldset = targetElement;
                             targetFieldset.style.display = action == 'show' ? 'none' : 'block';
                             targetFieldset.dataset.notIncluded = action == 'show' ? true : false;
                             if (action == 'show') {
                                resetInputValues(targetFieldset);
                                // window.singleHandleChange(event)
                             }
                          }
                          else {
                             const targetItemInput = targetElement;
                             const targetItemParent = targetItemInput.parentNode;
                             targetItemParent.style.display = action == 'show' ? 'none' : 'block';
                             targetItemInput.dataset.notIncluded = action == 'show' ? true : false;
                             const customChangeEvent = new Event("change", {
                                bubbles: true,
                             });
                          }
                       });
                       ///////////////////////////////////////////////////////////////
                    }
                 });
              }
              ///////////////////////////////////////////////////////////////
              if (type === 'radio' || type === 'image' || type === 'pill') {
                 const normalizedCategoryName = categoryName.toLowerCase().split(" ").join("-");
                 const fieldsetSelector = `${uniqueSelector} .foodify-fieldset[data-type="${normalizedCategoryName}"]`;
                 waitForElmFoodify(fieldsetSelector).then(() => {
                    setTimeout(() => {
                       //-console.log(secondCondition)
                       if (secondCondition.some(condition => condition.includes("-native-variant"))) {
                          //-console.log("native variant")
                          ////////////// NATIVE VARIANT ///////////////////////////////////
                          const inputs = document.querySelectorAll(`${uniqueSelector} variant-radios input[type="radio"].native-variant`);
                          const checkedValue = [...inputs].find(input => input.checked)?.value || "No checked input found";
                          //-console.log("checkedValue", checkedValue);
                          const modifiedSecondCondition = secondCondition.map(condition => condition.replace("-native-variant", ""));
                          const isSelected = modifiedSecondCondition.includes(checkedValue);
                          //-console.log("isSelected", isSelected);
                          const inCategory = category === event.target.name.replace("properties[", "").replace("]", "");
                          if (isSelected) {
                             const displayStyle = action === 'show' ? 'block' : 'none';
                             const notIncluded = action !== 'show';
                             ruleFields.forEach(field => {
                                const hasCategory = field.name.includes(" - Category");
                                const targetName = hasCategory ? field.name.split(" - Category")[0] : field.name;
                                const targetSelector = hasCategory ?
                                   `${uniqueSelector} .foodify-fieldset[data-type="${targetName.toLowerCase().split(" ").join("-")}"]` :
                                   `${uniqueSelector} .foodify-fieldset input[value="${field.name}"]`;
                                let targetElement = document.querySelector(targetSelector);
                                if (field.name.includes(" - Native Variant")) {
                                   targetElement = document.querySelector(`${uniqueSelector} input[value="${field.name.replace(" - Native Variant", "")}"]`);
                                   if (targetElement && targetElement.checked) {
                                      if (displayStyle == 'none') {
                                         const productOptions = document.getElementById("product-options");
                                         if (productOptions && productOptions.hasAttribute("data-base-default") && isSelected) {
                                            productOptions.setAttribute("data-base", productOptions.getAttribute("data-base-default"));
                                         }
                                      }
                                   }
                                }
                                if (hasCategory) {
                                   targetElement.style.display = displayStyle;
                                   targetElement.dataset.notIncluded = notIncluded;
                                } else {
                                   const targetItemParent = targetElement.parentNode;
                                   targetItemParent.style.display = displayStyle;
                                   targetElement.dataset.notIncluded = notIncluded;
                                   targetElement.checked = false;
                                }
                             });
                          }
                          else {
                             const lastClicked = event.target.getAttribute('data-last-clicked') !== 'true';
                             const displayStyle = action === 'show' ? 'block' : 'none';
                             const notIncluded = action !== 'show';
                             ruleFields.forEach(field => {
                                const hasCategory = field.name.includes(" - Category");
                                const targetName = hasCategory ? field.name.split(" - Category")[0] : field.name;
                                const targetSelector = hasCategory ?
                                   `${uniqueSelector} .foodify-fieldset[data-type="${targetName.toLowerCase().split(" ").join("-")}"]` :
                                   `${uniqueSelector} .foodify-fieldset input[value="${field.name}"]`;
                                let targetElement = document.querySelector(targetSelector);
                                ///////////////////////////////////////////
                                if (field.name.includes(" - Native Variant")) {
                                   targetElement = document.querySelector(`${uniqueSelector} input[value="${field.name.replace(" - Native Variant", "")}"]`);
                                   if (targetElement && targetElement.checked) {
                                      // The radio button is checked
                                      if (displayStyle == 'none') {
                                         //-console.log("REST----------------",displayStyle,isSelected)
                                         const productOptions = document.getElementById("product-options");
                                         if (productOptions && productOptions.hasAttribute("data-base-default") && isSelected) {
                                            productOptions.setAttribute("data-base", productOptions.getAttribute("data-base-default"));
                                         }
                                      }
                                   }
                                }
                                ///////////////////////////////////////////
                                const oppositeDisplayStyle = action === 'show' ? 'none' : 'block';
                                if (hasCategory) {
                                   targetElement.style.display = oppositeDisplayStyle;
                                   targetElement.dataset.notIncluded = !notIncluded;
                                   if (action === 'show') {
                                      resetInputValues(targetElement);
                                      // window.singleHandleChange(event);
                                   }
                                } else {
                                   const targetItemParent = targetElement.parentNode;
                                   targetItemParent.style.display = oppositeDisplayStyle;
                                   targetElement.dataset.notIncluded = !notIncluded;
                                   if (action === 'show') {
                                      resetInputValues(targetElement, event);
                                      // window.singleHandleChange(event);
                                   }
                                }
                             });
                          }
                          ////////////// END NATIVE VARIANT ///////////////////////////////
                       }
                       else {
                          //-console.log("not native variant")
                          ////////////// NOT NATIVE VARIANT ///////////////////////////////////
                          const fieldset = document.querySelector(fieldsetSelector);
                          const inputs = fieldset.querySelectorAll(`input[type="radio"][name="properties[${category}]"]`);
                          const checkedValue = [...inputs].find(input => input.checked)?.value || "No checked input found";
                          const getCheckedValue = (inputs) => {
                             let dataLastClickedValue = 'No checked input found';
                             inputs.forEach(input => {
                                if (input.type.toLowerCase() === 'radio') {
                                   const dataLastClicked = input.getAttribute('data-last-clicked');
                                   if (dataLastClicked === 'true') {
                                      dataLastClickedValue = input.value;
                                   }
                                   if (input.checked && dataLastClickedValue === '') {
                                      dataLastClickedValue = input.value;
                                   }
                                }
                             });
                             let allDataLastClickedFalse = true;
                             inputs.forEach(input => {
                                const dataLastClicked = input.getAttribute('data-last-clicked');
                                if (dataLastClicked === 'true') {
                                   allDataLastClickedFalse = false;
                                }
                             });
                             return allDataLastClickedFalse ? 'No checked input found' : dataLastClickedValue;
                          };
                          // const isSelected = checkedValue === secondCondition;
                          const isSelected = secondCondition.some(condition => {
                             if (condition.includes('-native-variant')) {
                                return checkedValue === condition.replace('-native-variant', '');
                             } else {
                                return checkedValue === condition;
                             }
                          });
                          const inCategory = category === event.target.name.replace("properties[", "").replace("]", "")
                          // console.log("getCheckedValue", getCheckedValue(inputs), checkedValue, event.target.getAttribute('data-last-clicked'), isSelected, inCategory)
                          if (isSelected) {
                             const lastClicked = event.target.getAttribute('data-last-clicked') !== 'true';
                             const displayStyle = action === 'show' ? 'block' : 'none';
                             const notIncluded = action !== 'show';
                             // console.log("getCheckedValue", getCheckedValue(inputs), checkedValue, event.target.getAttribute('data-last-clicked'), isSelected, inCategory)
                             ruleFields.forEach(field => {
                                const hasCategory = field.name.includes(" - Category");
                                const targetName = hasCategory ? field.name.split(" - Category")[0] : field.name;
                                const targetSelector = hasCategory ?
                                   `${uniqueSelector} .foodify-fieldset[data-type="${targetName.toLowerCase().split(" ").join("-")}"]` :
                                   `${uniqueSelector} .foodify-fieldset input[value="${field.name}"]`;
                                let targetElement = document.querySelector(targetSelector);
                                ///////////////////////////////////////////
                                if (field.name.includes(" - Native Variant")) {
                                   targetElement = document.querySelector(`${uniqueSelector} input[value="${field.name.replace(" - Native Variant", "")}"]`);
                                   if (targetElement && targetElement.checked) {
                                      // The radio button is checked
                                      if (displayStyle == 'none') {
                                         //-console.log("REST----------------",displayStyle,isSelected)
                                         const productOptions = document.getElementById("product-options");
                                         if (productOptions && productOptions.hasAttribute("data-base-default") && isSelected) {
                                            productOptions.setAttribute("data-base", productOptions.getAttribute("data-base-default"));
                                         }
                                      }
                                   }
                                }
                                ///////////////////////////////////////////
                                if (hasCategory) {
                                   targetElement.style.display = displayStyle;
                                   targetElement.dataset.notIncluded = notIncluded;
                                } else {
                                   const targetItemParent = targetElement.parentNode;
                                   targetItemParent.style.display = displayStyle;
                                   targetElement.dataset.notIncluded = notIncluded;
                                   targetElement.checked = false;
                                }
                             });
                          }
                          else {
                             const lastClicked = event.target.getAttribute('data-last-clicked') !== 'true';
                             const displayStyle = action === 'show' ? 'block' : 'none';
                             const notIncluded = action !== 'show';
                             ruleFields.forEach(field => {
                                const hasCategory = field.name.includes(" - Category");
                                const targetName = hasCategory ? field.name.split(" - Category")[0] : field.name;
                                const targetSelector = hasCategory ?
                                   `${uniqueSelector} .foodify-fieldset[data-type="${targetName.toLowerCase().split(" ").join("-")}"]` :
                                   `${uniqueSelector} .foodify-fieldset input[value="${field.name}"]`;
                                let targetElement = document.querySelector(targetSelector);
                                ///////////////////////////////////////////
                                if (field.name.includes(" - Native Variant")) {
                                   targetElement = document.querySelector(`${uniqueSelector} input[value="${field.name.replace(" - Native Variant", "")}"]`);
                                   if (targetElement && targetElement.checked) {
                                      // The radio button is checked
                                      if (displayStyle == 'none') {
                                         //-console.log("REST----------------",displayStyle,isSelected)
                                         const productOptions = document.getElementById("product-options");
                                         if (productOptions && productOptions.hasAttribute("data-base-default") && isSelected) {
                                            productOptions.setAttribute("data-base", productOptions.getAttribute("data-base-default"));
                                         }
                                      }
                                   }
                                }
                                ///////////////////////////////////////////
                                const oppositeDisplayStyle = action === 'show' ? 'none' : 'block';
                                if (hasCategory) {
                                   targetElement.style.display = oppositeDisplayStyle;
                                   targetElement.dataset.notIncluded = !notIncluded;
                                   if (action === 'show') {
                                      resetInputValues(targetElement);
                                      // window.singleHandleChange(event);
                                   }
                                } else {
                                   const targetItemParent = targetElement.parentNode;
                                   targetItemParent.style.display = oppositeDisplayStyle;
                                   targetElement.dataset.notIncluded = !notIncluded;
                                   if (action === 'show') {
                                      resetInputValues(targetElement, event);
                                      // window.singleHandleChange(event);
                                   }
                                }
                             });
                          }
                          ////////////// END NOT NATIVE VARIANT ///////////////////////////////
                       }
                    }, 50);
                 });
              }
              ///////////////////////////////////////////////////////////////
              if (type == 'select') {
                 waitForElmFoodify(`${uniqueSelector} .foodify-fieldset[data-type="${categoryName.toLowerCase().split(" ").join("-")}"]`).then((elm) => {
                    const fieldset = document.querySelector(`${uniqueSelector} .foodify-fieldset[data-type="${categoryName.toLowerCase().split(" ").join("-")}"]`)
                    setTimeout(() => {}, 1000);
                    // const isSelected = document.querySelector(`${uniqueSelector} select[name="properties[${category}]"]`)?.value === secondCondition;
                    const isSelected = secondCondition.some(condition => {
                       return document.querySelector(`${uniqueSelector} select[name="properties[${category}]"]`)?.value === condition;
                    });
                    if (isSelected) {
                       ruleFields.forEach(field => {
                          const hasCategory = field.name.includes(" - Category");
                          const target = hasCategory ? field.name.split(" - Category")[0] : field.name;
                          const targetSelector = hasCategory ? `${uniqueSelector} .foodify-fieldset[data-type="${target.toLowerCase().split(" ").join("-")}"]` : `${uniqueSelector} .foodify-fieldset input[value="${field.name}"]`;
                          const targetElement = document.querySelector(targetSelector);
                          if (hasCategory) {
                             const targetFieldset = targetElement;
                             targetFieldset.style.display = action == 'show' ? 'block' : 'none';
                             targetFieldset.dataset.notIncluded = action == 'show' ? false : true;
                             if (action == 'hide') {
                                resetInputValues(targetFieldset);
                                // window.singleHandleChange(event)
                             }
                          } else {
                             const targetItemInput = targetElement;
                             const targetItemParent = targetItemInput.parentNode;
                             targetItemParent.style.display = action == 'show' ? 'block' : 'none';
                             targetItemInput.dataset.notIncluded = action == 'show' ? false : true;
                             targetItemInput.checked = false;
                             const customChangeEvent = new Event("change", {
                                bubbles: true,
                             });
                          }
                       });
                    }
                    else {
                       ruleFields.forEach(field => {
                          const hasCategory = field.name.includes(" - Category");
                          const target = hasCategory ? field.name.split(" - Category")[0] : field.name;
                          const targetSelector = hasCategory ? `${uniqueSelector} .foodify-fieldset[data-type="${target.toLowerCase().split(" ").join("-")}"]` : `${uniqueSelector} .foodify-fieldset input[value="${field.name}"]`;
                          let targetElement = document.querySelector(targetSelector);
                          if (field.name.includes(" - Native Variant")) {
                             // targetElement
                          }
                          // variant-radios
                          if (!targetElement) {
                             //-console.log(field.name)
                             //-console.log(field)
                          }
                          if (hasCategory) {
                             const targetFieldset = targetElement;
                             targetFieldset.style.display = action == 'show' ? 'none' : 'block';
                             targetFieldset.dataset.notIncluded = action == 'show' ? true : false;
                             if (action == 'show') {
                                resetInputValues(targetFieldset);
                                // window.singleHandleChange(event)
                             }
                          } else {
                             const targetItemInput = targetElement;
                             const targetItemParent = targetItemInput.parentNode;
                             targetItemParent.style.display = action == 'show' ? 'none' : 'block';
                             targetItemInput.dataset.notIncluded = action == 'show' ? true : false;
                             const customChangeEvent = new Event("change", {
                                bubbles: true,
                             });
                          }
                       });
                    }
                 });
              }
              ///////////////////////////////////////////////////////////////
           }
           ///////////////////////////////////////////////////////////////
           if (firstCondition == 'limit' || firstCondition == 'total-selected' || secondCondition.includes('total-selected') || secondCondition.includes('limit')) {
              ///////////////////////////////////////////////////////////////
              const processRuleFields = (isConditionMet) => {
                 ruleFields.forEach(field => {
                    const hasCategory = field.name.includes(" - Category");
                    const target = hasCategory ? field.name.split(" - Category")[0] : field.name;
                    const targetSelector = hasCategory ? `${uniqueSelector} .foodify-fieldset[data-type="${target.toLowerCase().split(" ").join("-")}"]` : `${uniqueSelector} .foodify-fieldset input[value="${field.name}"]`;
                    const targetElement = document.querySelector(targetSelector);
                    if (hasCategory) {
                       const targetFieldset = targetElement;
                       if (targetFieldset) {
                          targetFieldset.style.display = isConditionMet ? (action == 'show' ? 'block' : 'none') : (action == 'hide' ? 'block' : 'none');
                          targetFieldset.dataset.notIncluded = isConditionMet.toString() == 'true' ? 'false' : 'true';
                          if (action == 'show') {
                             resetInputValues(targetFieldset);
                             // window.singleHandleChange(event)
                          }
                       }
                    }
                    else {
                       const targetItemInput = targetElement;
                       const targetItemParent = targetItemInput.parentNode;
                       targetItemInput.dataset.notIncluded = isConditionMet.toString() == 'true' ? 'false' : 'true';
                       targetItemParent.style.display = isConditionMet ? (action == 'show' ? 'block' : 'none') : (action == 'hide' ? 'block' : 'none');
                    }
                 });
              };
              ///////////////////////////////////////////////////////////////
              const checkAndProcessCondition = (condition, category) => {
                 const grabTotalSelectedInCategory = document.querySelectorAll(`${uniqueSelector} .foodify-fieldset[data-type="${category.toLowerCase().split(" ").join("-")}"] input[type="checkbox"]`);
                 const totalSelectedCount = grabTotalSelectedInCategory ? Array.from(grabTotalSelectedInCategory).filter(item => item.checked).length : 0;
                 let isConditionMet = false;
                 if (firstCondition === 'limit' && secondCondition.includes('total-selected')) {
                    if (condition === 'greater') isConditionMet = (Number(limit) > totalSelectedCount);
                    else if (condition === 'equal') isConditionMet = (totalSelectedCount === Number(limit));
                    else if (condition === 'less') isConditionMet = (Number(limit) < totalSelectedCount);
                    processRuleFields(isConditionMet);
                 }
              };
              ///////////////////////////////////////////////////////////////
              checkAndProcessCondition(conditionLink, category);
           }
           ///////////////////////////////////////////////////////////////
           setTimeout(() => {
              updateOptionsPrice(uniqueSelector);
           }, 200);
        }
     }
     else {
        // IF USING OLD FORMAT FOR SINGLE VALUE SECOND CONDITION
        //-console.log("OLD FORMAT")
        if (ruleFields) {
           ///////////////////////////////////////////////////////////////
           if (firstCondition != 'limit' && firstCondition != 'total-selected' && secondCondition != 'total-selected' && secondCondition != 'limit') {
              ///////////////////////////////////////////////////////////////
              if (type == 'checkbox' || type == 'image-multi') {
                 waitForElmFoodify(`${uniqueSelector} .foodify-fieldset[data-type="${categoryName.toLowerCase().split(" ").join("-")}"]`).then((elm) => {
                    const fieldset = document.querySelector(`${uniqueSelector} .foodify-fieldset[data-type="${categoryName.toLowerCase().split(" ").join("-")}"]`)
                    setTimeout(() => {}, 1000);
                    const inputs = fieldset.querySelectorAll(`input[type="checkbox"][name^="properties[${category}"]`);
                    const checkedValues = Array.from(inputs).filter(input => input.checked).map(input => input.value);
                    const isSelected = checkedValues.includes(secondCondition);
                    if (isSelected) {
                       //////////////////////////////////////////////////////////////////
                       ruleFields.forEach(field => {
                          const hasCategory = field.name.includes(" - Category");
                          const target = hasCategory ? field.name.split(" - Category")[0] : field.name;
                          const targetSelector = hasCategory ? `${uniqueSelector} .foodify-fieldset[data-type="${target.toLowerCase().split(" ").join("-")}"]` : `${uniqueSelector} .foodify-fieldset input[value="${field.name}"]`;
                          const targetElement = document.querySelector(targetSelector);
                          if (hasCategory) {
                             const targetFieldset = targetElement;
                             targetFieldset.style.display = action == 'show' ? 'block' : 'none';
                             targetFieldset.dataset.notIncluded = action == 'show' ? false : true;
                             if (action != 'show') {
                                resetInputValues(targetFieldset);
                             }
                          }
                          else {
                             const targetItemInput = targetElement;
                             const targetItemParent = targetItemInput.parentNode;
                             targetItemParent.style.display = action == 'show' ? 'block' : 'none';
                             targetItemInput.dataset.notIncluded = action == 'show' ? false : true;
                             targetItemInput.checked = false;
                             const customChangeEvent = new Event("change", {
                                bubbles: true,
                             });
                          }
                       });
                       //////////////////////////////////////////////////////////////////
                    }
                    else {
                       ///////////////////////////////////////////////////////////////
                       ruleFields.forEach(field => {
                          const hasCategory = field.name.includes(" - Category");
                          const target = hasCategory ? field.name.split(" - Category")[0] : field.name;
                          const targetSelector = hasCategory ? `${uniqueSelector} .foodify-fieldset[data-type="${target.toLowerCase().split(" ").join("-")}"]` : `${uniqueSelector} .foodify-fieldset input[value="${field.name}"]`;
                          const targetElement = document.querySelector(targetSelector);
                          if (hasCategory) {
                             const targetFieldset = targetElement;
                             targetFieldset.style.display = action == 'show' ? 'none' : 'block';
                             targetFieldset.dataset.notIncluded = action == 'show' ? true : false;
                             if (action == 'show') {
                                resetInputValues(targetFieldset);
                                // window.singleHandleChange(event)
                             }
                          }
                          else {
                             const targetItemInput = targetElement;
                             const targetItemParent = targetItemInput.parentNode;
                             targetItemParent.style.display = action == 'show' ? 'none' : 'block';
                             targetItemInput.dataset.notIncluded = action == 'show' ? true : false;
                             const customChangeEvent = new Event("change", {
                                bubbles: true,
                             });
                          }
                       });
                       ///////////////////////////////////////////////////////////////
                    }
                 });
              }
              ///////////////////////////////////////////////////////////////
              if (type === 'radio' || type === 'image' || type === 'pill') {
                 const normalizedCategoryName = categoryName.toLowerCase().split(" ").join("-");
                 const fieldsetSelector = `${uniqueSelector} .foodify-fieldset[data-type="${normalizedCategoryName}"]`;
                 waitForElmFoodify(fieldsetSelector).then(() => {
                    setTimeout(() => {
                       if (secondCondition.includes("-native-variant")) {
                          //-console.log("native variant")
                          ////////////// NATIVE VARIANT ///////////////////////////////////
                          // const fieldset = document.querySelector(fieldsetSelector);
                          const inputs = document.querySelectorAll(`${uniqueSelector} variant-radios input[type="radio"].native-variant `); //[name="properties[${category}]"]
                          // console.log("inputs", inputs)
                          const checkedValue = [...inputs].find(input => input.checked)?.value || "No checked input found";
                          //-console.log("checkedValue", checkedValue)
                          const getCheckedValue = (inputs) => {
                             let dataLastClickedValue = 'No checked input found';
                             inputs.forEach(input => {
                                if (input.type.toLowerCase() === 'radio') {
                                   const dataLastClicked = input.getAttribute('data-last-clicked');
                                   if (dataLastClicked === 'true') {
                                      dataLastClickedValue = input.value;
                                   }
                                   if (input.checked && dataLastClickedValue === '') {
                                      dataLastClickedValue = input.value;
                                   }
                                }
                             });
                             let allDataLastClickedFalse = true;
                             inputs.forEach(input => {
                                const dataLastClicked = input.getAttribute('data-last-clicked');
                                if (dataLastClicked === 'true') {
                                   allDataLastClickedFalse = false;
                                }
                             });
                             return allDataLastClickedFalse ? 'No checked input found' : dataLastClickedValue;
                          };
                          const isSelected = checkedValue === secondCondition.replace("-native-variant", "");
                          //-console.log(isSelected)
                          const inCategory = category === event.target.name.replace("properties[", "").replace("]", "")
                          // console.log("getCheckedValue", getCheckedValue(inputs), checkedValue, event.target.getAttribute('data-last-clicked'), isSelected, inCategory)
                          if (isSelected) {
                             const lastClicked = event.target.getAttribute('data-last-clicked') !== 'true';
                             const displayStyle = action === 'show' ? 'block' : 'none';
                             const notIncluded = action !== 'show';
                             // console.log("getCheckedValue", getCheckedValue(inputs), checkedValue, event.target.getAttribute('data-last-clicked'), isSelected, inCategory)
                             ruleFields.forEach(field => {
                                const hasCategory = field.name.includes(" - Category");
                                const targetName = hasCategory ? field.name.split(" - Category")[0] : field.name;
                                const targetSelector = hasCategory ?
                                   `${uniqueSelector} .foodify-fieldset[data-type="${targetName.toLowerCase().split(" ").join("-")}"]` :
                                   `${uniqueSelector} .foodify-fieldset input[value="${field.name}"]`;
                                let targetElement = document.querySelector(targetSelector);
                                ///////////////////////////////////////////
                                if (field.name.includes(" - Native Variant")) {
                                   targetElement = document.querySelector(`${uniqueSelector} input[value="${field.name.replace(" - Native Variant", "")}"]`);
                                   if (targetElement && targetElement.checked) {
                                      // The radio button is checked
                                      if (displayStyle == 'none') {
                                         //-console.log("REST----------------",displayStyle,isSelected)
                                         const productOptions = document.getElementById("product-options");
                                         if (productOptions && productOptions.hasAttribute("data-base-default") && isSelected) {
                                            productOptions.setAttribute("data-base", productOptions.getAttribute("data-base-default"));
                                         }
                                      }
                                   }
                                }
                                ///////////////////////////////////////////
                                if (hasCategory) {
                                   targetElement.style.display = displayStyle;
                                   targetElement.dataset.notIncluded = notIncluded;
                                } else {
                                   //-console.log("xxxxxxxxx")
                                   const targetItemParent = targetElement.parentNode;
                                   targetItemParent.style.display = displayStyle;
                                   targetElement.dataset.notIncluded = notIncluded;
                                   targetElement.checked = false;
                                }
                             });
                          }
                          else {
                             const lastClicked = event.target.getAttribute('data-last-clicked') !== 'true';
                             const displayStyle = action === 'show' ? 'block' : 'none';
                             const notIncluded = action !== 'show';
                             ruleFields.forEach(field => {
                                const hasCategory = field.name.includes(" - Category");
                                const targetName = hasCategory ? field.name.split(" - Category")[0] : field.name;
                                const targetSelector = hasCategory ?
                                   `${uniqueSelector} .foodify-fieldset[data-type="${targetName.toLowerCase().split(" ").join("-")}"]` :
                                   `${uniqueSelector} .foodify-fieldset input[value="${field.name}"]`;
                                let targetElement = document.querySelector(targetSelector);
                                ///////////////////////////////////////////
                                if (field.name.includes(" - Native Variant")) {
                                   targetElement = document.querySelector(`${uniqueSelector} input[value="${field.name.replace(" - Native Variant", "")}"]`);
                                   if (targetElement && targetElement.checked) {
                                      // The radio button is checked
                                      if (displayStyle == 'none') {
                                         //-console.log("REST----------------",displayStyle,isSelected)
                                         const productOptions = document.getElementById("product-options");
                                         if (productOptions && productOptions.hasAttribute("data-base-default") && isSelected) {
                                            productOptions.setAttribute("data-base", productOptions.getAttribute("data-base-default"));
                                            //-console.log(checkedValue)
                                            //-console.log(field.name)
                                         }
                                      }
                                   }
                                }
                                ///////////////////////////////////////////
                                const oppositeDisplayStyle = action === 'show' ? 'none' : 'block';
                                if (hasCategory) {
                                   targetElement.style.display = oppositeDisplayStyle;
                                   targetElement.dataset.notIncluded = !notIncluded;
                                   if (action === 'show') {
                                      resetInputValues(targetElement);
                                      // window.singleHandleChange(event);
                                   }
                                } else {
                                   const targetItemParent = targetElement.parentNode;
                                   targetItemParent.style.display = oppositeDisplayStyle;
                                   targetElement.dataset.notIncluded = !notIncluded;
                                   if (action === 'show') {
                                      resetInputValues(targetElement, event);
                                      // window.singleHandleChange(event);
                                   }
                                }
                             });
                          }
                          ////////////// END NATIVE VARIANT ///////////////////////////////
                       }
                       else {
                          ////////////// NOT NATIVE VARIANT ///////////////////////////////////
                          const fieldset = document.querySelector(fieldsetSelector);
                          const inputs = fieldset.querySelectorAll(`input[type="radio"][name="properties[${category}]"]`);
                          const checkedValue = [...inputs].find(input => input.checked)?.value || "No checked input found";
                          const getCheckedValue = (inputs) => {
                             let dataLastClickedValue = 'No checked input found';
                             inputs.forEach(input => {
                                if (input.type.toLowerCase() === 'radio') {
                                   const dataLastClicked = input.getAttribute('data-last-clicked');
                                   if (dataLastClicked === 'true') {
                                      dataLastClickedValue = input.value;
                                   }
                                   if (input.checked && dataLastClickedValue === '') {
                                      dataLastClickedValue = input.value;
                                   }
                                }
                             });
                             let allDataLastClickedFalse = true;
                             inputs.forEach(input => {
                                const dataLastClicked = input.getAttribute('data-last-clicked');
                                if (dataLastClicked === 'true') {
                                   allDataLastClickedFalse = false;
                                }
                             });
                             return allDataLastClickedFalse ? 'No checked input found' : dataLastClickedValue;
                          };
                          const isSelected = checkedValue === secondCondition;
                          const inCategory = category === event.target.name.replace("properties[", "").replace("]", "")
                          // console.log("getCheckedValue", getCheckedValue(inputs), checkedValue, event.target.getAttribute('data-last-clicked'), isSelected, inCategory)
                          if (isSelected) {
                             const lastClicked = event.target.getAttribute('data-last-clicked') !== 'true';
                             const displayStyle = action === 'show' ? 'block' : 'none';
                             const notIncluded = action !== 'show';
                             // console.log("getCheckedValue", getCheckedValue(inputs), checkedValue, event.target.getAttribute('data-last-clicked'), isSelected, inCategory)
                             ruleFields.forEach(field => {
                                const hasCategory = field.name.includes(" - Category");
                                const targetName = hasCategory ? field.name.split(" - Category")[0] : field.name;
                                const targetSelector = hasCategory ?
                                   `${uniqueSelector} .foodify-fieldset[data-type="${targetName.toLowerCase().split(" ").join("-")}"]` :
                                   `${uniqueSelector} .foodify-fieldset input[value="${field.name}"]`;
                                let targetElement = document.querySelector(targetSelector);
                                ///////////////////////////////////////////
                                if (field.name.includes(" - Native Variant")) {
                                   targetElement = document.querySelector(`${uniqueSelector} input[value="${field.name.replace(" - Native Variant", "")}"]`);
                                   if (targetElement && targetElement.checked) {
                                      // The radio button is checked
                                      if (displayStyle == 'none') {
                                         //-console.log("REST----------------",displayStyle,isSelected)
                                         const productOptions = document.getElementById("product-options");
                                         if (productOptions && productOptions.hasAttribute("data-base-default") && isSelected) {
                                            productOptions.setAttribute("data-base", productOptions.getAttribute("data-base-default"));
                                            //-console.log(checkedValue)
                                            //-console.log(field.name)
                                         }
                                      }
                                   }
                                }
                                ///////////////////////////////////////////
                                if (hasCategory) {
                                   targetElement.style.display = displayStyle;
                                   targetElement.dataset.notIncluded = notIncluded;
                                } else {
                                   const targetItemParent = targetElement.parentNode;
                                   targetItemParent.style.display = displayStyle;
                                   targetElement.dataset.notIncluded = notIncluded;
                                   targetElement.checked = false;
                                }
                             });
                          }
                          else {
                             const lastClicked = event.target.getAttribute('data-last-clicked') !== 'true';
                             const displayStyle = action === 'show' ? 'block' : 'none';
                             const notIncluded = action !== 'show';
                             ruleFields.forEach(field => {
                                const hasCategory = field.name.includes(" - Category");
                                const targetName = hasCategory ? field.name.split(" - Category")[0] : field.name;
                                const targetSelector = hasCategory ?
                                   `${uniqueSelector} .foodify-fieldset[data-type="${targetName.toLowerCase().split(" ").join("-")}"]` :
                                   `${uniqueSelector} .foodify-fieldset input[value="${field.name}"]`;
                                let targetElement = document.querySelector(targetSelector);
                                ///////////////////////////////////////////
                                if (field.name.includes(" - Native Variant")) {
                                   targetElement = document.querySelector(`${uniqueSelector} input[value="${field.name.replace(" - Native Variant", "")}"]`);
                                   if (targetElement && targetElement.checked) {
                                      // The radio button is checked
                                      if (displayStyle == 'none') {
                                         //-console.log("REST----------------",displayStyle,isSelected)
                                         const productOptions = document.getElementById("product-options");
                                         if (productOptions && productOptions.hasAttribute("data-base-default") && isSelected) {
                                            productOptions.setAttribute("data-base", productOptions.getAttribute("data-base-default"));
                                            //-console.log(checkedValue)
                                            //-console.log(field.name)
                                         }
                                      }
                                   }
                                }
                                ///////////////////////////////////////////
                                const oppositeDisplayStyle = action === 'show' ? 'none' : 'block';
                                if (hasCategory) {
                                   targetElement.style.display = oppositeDisplayStyle;
                                   targetElement.dataset.notIncluded = !notIncluded;
                                   if (action === 'show') {
                                      resetInputValues(targetElement);
                                      // window.singleHandleChange(event);
                                   }
                                } else {
                                   const targetItemParent = targetElement.parentNode;
                                   targetItemParent.style.display = oppositeDisplayStyle;
                                   targetElement.dataset.notIncluded = !notIncluded;
                                   if (action === 'show') {
                                      resetInputValues(targetElement, event);
                                      // window.singleHandleChange(event);
                                   }
                                }
                             });
                          }
                          ////////////// END NOT NATIVE VARIANT ///////////////////////////////
                       }
                    }, 50);
                 });
              }
              ///////////////////////////////////////////////////////////////
              if (type == 'select') {
                 waitForElmFoodify(`${uniqueSelector} .foodify-fieldset[data-type="${categoryName.toLowerCase().split(" ").join("-")}"]`).then((elm) => {
                    const fieldset = document.querySelector(`${uniqueSelector} .foodify-fieldset[data-type="${categoryName.toLowerCase().split(" ").join("-")}"]`)
                    setTimeout(() => {}, 1000);
                    const isSelected = document.querySelector(`${uniqueSelector} select[name="properties[${category}]"]`)?.value === secondCondition;
                    if (isSelected) {
                       ruleFields.forEach(field => {
                          const hasCategory = field.name.includes(" - Category");
                          const target = hasCategory ? field.name.split(" - Category")[0] : field.name;
                          const targetSelector = hasCategory ? `${uniqueSelector} .foodify-fieldset[data-type="${target.toLowerCase().split(" ").join("-")}"]` : `${uniqueSelector} .foodify-fieldset input[value="${field.name}"]`;
                          const targetElement = document.querySelector(targetSelector);
                          if (hasCategory) {
                             const targetFieldset = targetElement;
                             targetFieldset.style.display = action == 'show' ? 'block' : 'none';
                             targetFieldset.dataset.notIncluded = action == 'show' ? false : true;
                             if (action == 'hide') {
                                resetInputValues(targetFieldset);
                                // window.singleHandleChange(event)
                             }
                          } else {
                             const targetItemInput = targetElement;
                             const targetItemParent = targetItemInput.parentNode;
                             targetItemParent.style.display = action == 'show' ? 'block' : 'none';
                             targetItemInput.dataset.notIncluded = action == 'show' ? false : true;
                             targetItemInput.checked = false;
                             const customChangeEvent = new Event("change", {
                                bubbles: true,
                             });
                          }
                       });
                    }
                    else {
                       ruleFields.forEach(field => {
                          const hasCategory = field.name.includes(" - Category");
                          const target = hasCategory ? field.name.split(" - Category")[0] : field.name;
                          const targetSelector = hasCategory ? `${uniqueSelector} .foodify-fieldset[data-type="${target.toLowerCase().split(" ").join("-")}"]` : `${uniqueSelector} .foodify-fieldset input[value="${field.name}"]`;
                          let targetElement = document.querySelector(targetSelector);
                          if (field.name.includes(" - Native Variant")) {
                             // targetElement
                          }
                          if (!targetElement) {
                             //-console.log(field.name)
                             //-console.log(field)
                          }
                          if (hasCategory) {
                             const targetFieldset = targetElement;
                             targetFieldset.style.display = action == 'show' ? 'none' : 'block';
                             targetFieldset.dataset.notIncluded = action == 'show' ? true : false;
                             if (action == 'show') {
                                resetInputValues(targetFieldset);
                                // window.singleHandleChange(event)
                             }
                          } else {
                             const targetItemInput = targetElement;
                             const targetItemParent = targetItemInput.parentNode;
                             targetItemParent.style.display = action == 'show' ? 'none' : 'block';
                             targetItemInput.dataset.notIncluded = action == 'show' ? true : false;
                             const customChangeEvent = new Event("change", {
                                bubbles: true,
                             });
                          }
                       });
                    }
                 });
              }
              ///////////////////////////////////////////////////////////////
           }
           ///////////////////////////////////////////////////////////////
           if (firstCondition == 'limit' || firstCondition == 'total-selected' || secondCondition == 'total-selected' || secondCondition == 'limit') {
              ///////////////////////////////////////////////////////////////
              const processRuleFields = (isConditionMet) => {
                 ruleFields.forEach(field => {
                    const hasCategory = field.name.includes(" - Category");
                    const target = hasCategory ? field.name.split(" - Category")[0] : field.name;
                    const targetSelector = hasCategory ? `${uniqueSelector} .foodify-fieldset[data-type="${target.toLowerCase().split(" ").join("-")}"]` : `${uniqueSelector} .foodify-fieldset input[value="${field.name}"]`;
                    const targetElement = document.querySelector(targetSelector);
                    if (hasCategory) {
                       const targetFieldset = targetElement;
                       if (targetFieldset) {
                          targetFieldset.style.display = isConditionMet ? (action == 'show' ? 'block' : 'none') : (action == 'hide' ? 'block' : 'none');
                          targetFieldset.dataset.notIncluded = isConditionMet.toString() == 'true' ? 'false' : 'true';
                          if (action == 'show') {
                             resetInputValues(targetFieldset);
                             // window.singleHandleChange(event)
                          }
                       }
                    }
                    else {
                       const targetItemInput = targetElement;
                       const targetItemParent = targetItemInput.parentNode;
                       targetItemInput.dataset.notIncluded = isConditionMet.toString() == 'true' ? 'false' : 'true';
                       targetItemParent.style.display = isConditionMet ? (action == 'show' ? 'block' : 'none') : (action == 'hide' ? 'block' : 'none');
                    }
                 });
              };
              ///////////////////////////////////////////////////////////////
              const checkAndProcessCondition = (condition, category) => {
                 const grabTotalSelectedInCategory = document.querySelectorAll(`${uniqueSelector} .foodify-fieldset[data-type="${category.toLowerCase().split(" ").join("-")}"] input[type="checkbox"]`);
                 const totalSelectedCount = grabTotalSelectedInCategory ? Array.from(grabTotalSelectedInCategory).filter(item => item.checked).length : 0;
                 let isConditionMet = false;
                 if (firstCondition === 'limit' && secondCondition === 'total-selected') {
                    if (condition === 'greater') isConditionMet = (Number(limit) > totalSelectedCount);
                    else if (condition === 'equal') isConditionMet = (totalSelectedCount === Number(limit));
                    else if (condition === 'less') isConditionMet = (Number(limit) < totalSelectedCount);
                    processRuleFields(isConditionMet);
                 }
              };
              ///////////////////////////////////////////////////////////////
              checkAndProcessCondition(conditionLink, category);
           }
           ///////////////////////////////////////////////////////////////
           setTimeout(() => {
              updateOptionsPrice(uniqueSelector);
           }, 200);
        }
     }
  }
    
  function dispatchFirstInputChange(uniqueSelector) {
    waitForElmFoodify(`${uniqueSelector} #product-options .product-option select, #product-options .product-option input`).then((elm) => {
        elm.dispatchEvent(new Event('change', { bubbles: true }));
    });
    waitForElmFoodify(`${uniqueSelector} #product-options .product-option select, #product-options .product-option input[type="radio"]`).then((elm) => {
        elm.dispatchEvent(new Event('change', { bubbles: true }));
    }); 
  }
  
  /*  Mass Work  */
  function foodifyInitialize(storeData, forMultiple = false, uniqueSelector = '', singleProductData) {
       ///////////////////////////////////////////////////////////////
       //-console.log("load foodify")
    
       let currentProductSKU = forMultiple ? '' : ''
       let currentProductId = forMultiple ? singleProductData.productId : CFG.productId;
       let currentProductTitle = forMultiple ? singleProductData.productTitle : CFG.productTitle;
       let currentLineItemKey = forMultiple ? singleProductData.lineItemKey : ''
       const dataLine = {};
       let findSandwichById = (storeData, productId) => {
          for (let store of storeData) {
             if (store.sandwiches && store.sandwiches.length > 0) {
                let foundSandwich = store.sandwiches.find(sandwich => sandwich.id === productId);
                if (foundSandwich) return foundSandwich;
             }
          }
          return null;
       };
       if(forMultiple) {
           runParams();
       }
       else {
          if (window.hasSandwich) {
            runParams();
         }
       }
       
       function convertToURLParams(inputString) {
          return (inputString.split('+').join('%2B').replaceAll(' ', '+'));
       }
    
       function pushParameter(params) {
          const currentURL = new URL(window.location.href);
          currentURL.search = "";
          currentURL.search = `?${params}`;
          if(window.location.href.includes("/product")){
          history.replaceState({}, "", currentURL.toString());
          }
       }

       function runParams() {
          waitForElmFoodify(`${uniqueSelector} #product-options`).then((targetElement) => {
             waitForElmFoodify(`${uniqueSelector} #product-options input`).then((iElement) => {
                waitForElmFoodify(`${uniqueSelector} #product-options .product-option`).then((pElement) => {
                   selectionTracker(targetElement);
                });
             });
             selectionApplier(targetElement);
             setTimeout(() => {
                const firstCheckbox = targetElement.querySelector(`${uniqueSelector} #product-options .product-option input[type="checkbox"]`);
                if (firstCheckbox) {
                   const currentCheckedState = firstCheckbox.checked;
                   firstCheckbox.checked = !currentCheckedState;
                   firstCheckbox.checked = currentCheckedState;
                   const customChangeEvent = new Event("change", {
                      bubbles: true,
                   });
                   firstCheckbox.dispatchEvent(customChangeEvent);
                }
             }, 00);
          });
       }
    
       const getProductOptions = () => {
           const optionsData = [];
           document.querySelectorAll(`${uniqueSelector} .product-option`).forEach(fieldset => {
              const category = fieldset.getAttribute('data-type');
              fieldset.querySelectorAll('input:not(:disabled), select:not(:disabled)').forEach(element => {
                  if (element.tagName.toLowerCase() === 'select' && element.value === '') return;
                  const name = element.tagName.toLowerCase() === 'select' ? element.options[element.selectedIndex]?.text : element.value;
                  const optionId = element.id;
                  let selected;
                  if (element.type.toLowerCase() === 'radio') {
                  const dataLastClicked = element.getAttribute('data-last-clicked');
                  selected = dataLastClicked !== null ? dataLastClicked === 'true' : element.checked;
                  } 
                  else {
                  selected = element.tagName.toLowerCase() === 'select' ? element.value !== '' : element.checked;
                  }
                  const price = element.dataset.price;
                  optionsData.push({ category, name, optionId, selected, price });
              });
          });
           return optionsData;
        };
    
       function selectionTracker(targetElement) {
          const plWrapper = targetElement.querySelectorAll(".product-option");
          const handleChangeOthers = (event, label) => {
             if (event.detail && event.detail.exit && event.detail.exit === true) {
                return; 
             }
             let newString = "";
             plWrapper.forEach((wrapper) => {
                const label = wrapper.dataset.type;
                dataLine[label] = Array.isArray(dataLine[label]) ? dataLine[label] : [];
                const selects = wrapper.querySelector("select");
                const checkboxes = wrapper.querySelectorAll("input[type='checkbox']");
                const radioboxes = wrapper.querySelectorAll("input[type='radio']");
                newString += label + "=";
                if (selects) {
                   dataLine[label] = selects.value.trim();
                   newString += dataLine[label];
                }
                if (checkboxes.length > 0) {
                   checkboxes.forEach(checkbox => {
                      const valueToAdd = String(checkbox.value.trim());
                      if (checkbox.checked) {
                         if (!dataLine[label].includes(valueToAdd)) {
                            dataLine[label].push(valueToAdd);
                         }
                      } else {
                         dataLine[label] = dataLine[label].filter(item => item !== valueToAdd);
                      }
                   });
                }
             });
             updateOptionsPrice(uniqueSelector);
             setTimeout(() => {
                const options = getProductOptions();
                let groupedOptions = options.reduce((acc, { category, name, selected }) => {
                   if (selected) {
                      if (!acc[category]) {
                         acc[category] = [];
                      }
                      acc[category].push(name);
                   }
                   return acc;
                }, {});
                let urlParams = Object.entries(groupedOptions).map(([key, value]) => {
                   return `${key}=${value.join('_')}`;
                }).join('&');
                urlParams = `${urlParams}`;
                // console.log("p",urlParams);
                const doneParam = convertToURLParams(urlParams);
                // decodeParams(doneParam)
                if (!window.location.href.includes("/cart")) { pushParameter(doneParam) }
             }, 250)
          }
          const handleChangeRadio = (event) => {
             let newString = "";
             plWrapper.forEach((wrapper) => {
                ///////////////////////////////////////////////////////////////
                const label = wrapper.dataset.type;
                dataLine[label] = Array.isArray(dataLine[label]) ? dataLine[label] : [];
                const selects = wrapper.querySelector("select");
                const checkboxes = wrapper.querySelectorAll("input[type='checkbox']");
                const radioboxes = wrapper.querySelectorAll("input[type='radio']");
                newString += label + "=";
                if (radioboxes.length > 0) {
                   radioboxes.forEach(radiobox => {
                      const valueToAdd = String(radiobox.value.trim());
    
                      if (radiobox.value == event.target.value) {
    
                         if (!dataLine[label].includes(valueToAdd)) {
    
                            dataLine[label].push(valueToAdd); 
    
                         } else {
                            const nameAttribute = event.target.name; 
                            const startIndex = nameAttribute.indexOf('[') + 1;
                            const endIndex = nameAttribute.indexOf(']');
                            const extractedWord = nameAttribute.substring(startIndex, endIndex);
    
                            if (label.toLowerCase() == extractedWord.toLowerCase()) {
    
                               dataLine[label] = dataLine[label].filter(item => item !== valueToAdd);
    
                            }
    
                         }
                      } else {
                         const nameAttribute = event.target.name; 
                         const startIndex = nameAttribute.indexOf('[') + 1;
                         const endIndex = nameAttribute.indexOf(']');
                         const extractedWord = nameAttribute.substring(startIndex, endIndex);
    
                         if (label.toLowerCase() == extractedWord.toLowerCase()) {
                            dataLine[label] = dataLine[label].filter(item => item !== valueToAdd);
                         }
    
                      }
    
                   });
                }
                ///////////////////////////////////////////////////////////////
             });
             updateOptionsPrice(uniqueSelector);
             setTimeout(() => {
              const options = getProductOptions();
              let groupedOptions = options.reduce((acc, { category, name, selected }) => {
                 if (selected) {
                    if (!acc[category]) {
                       acc[category] = [];
                    }
                    acc[category].push(name);
                 }
                 return acc;
              }, {});
              let urlParams = Object.entries(groupedOptions).map(([key, value]) => {
                 return `${key}=${value.join('_')}`;
              }).join('&');
              urlParams = `${urlParams}`;
              // console.log(urlParams);
              const doneParam = convertToURLParams(urlParams);
              // decodeParams(doneParam)
              if (!window.location.href.includes("/cart")) { pushParameter(doneParam) }
           }, 250)
          }
          if (targetElement) {
             plWrapper.forEach((wrapper) => {
                ///////////////////////////////////////////////////////////////
                const label = wrapper.dataset.type;
                dataLine[label] = {};
                waitForElmFoodify(`${uniqueSelector} #product-options .product-option select`).then((dkm) => {
                   const selects = wrapper.querySelector("select");
                   if (selects) { selects.addEventListener("change", (event) => handleChangeOthers(event, label)); }
                });
                waitForElmFoodify(`${uniqueSelector} #product-options .product-option input[type="checkbox"]`).then((dkm) => {
                   const checkboxes = wrapper.querySelectorAll("input[type='checkbox']");
                   if (checkboxes) { checkboxes.forEach((checkbox) => checkbox.addEventListener("change", (event) => handleChangeOthers(event, label))); }
                });
                waitForElmFoodify(`${uniqueSelector} #product-options .product-option input[type="radio"]`).then((dkm) => {
                   const radioboxes = wrapper.querySelectorAll("input[type='radio']");
                   if (radioboxes) { radioboxes.forEach((radiobox) => radiobox.addEventListener("change", (event) => handleChangeRadio(event, label))); }
                });
                ///////////////////////////////////////////////////////////////
             });
          }
       }
    
       function selectionApplier(targetElement) {
          function decodeParams(params) {
            if(params){
             let uri = params.replaceAll("+", " ").split('%2B').join('+')
             return decodeURIComponent(uri);
            }
            else{
              return ''
             }
          }
          function extractValueFromParams(params, label) {
            const entries = params.split('&').map(param => {
              const [key, value] = param.split('=');
              return { key: decodeURIComponent(key), value: decodeURIComponent(value) };
            });
            const found = entries.find(entry => entry.key === label);
            return found ? found.value : null;
          }
          function extractValuesFromParams(params, label) {
            const entries = params.split('&').map(param => {
              const [key, value] = param.split('=');
              return { key: decodeURIComponent(key), value: decodeURIComponent(value) };
            });
            const found = entries.find(entry => entry.key === label);
            return found ? found.value.split('_') : [];
          }
          const urlString = window.location.href;
    
          const urlParams = urlString.split('?')[1];
          const decodedParams = decodeParams(urlParams);
          const pplrWrappers = targetElement.querySelectorAll(".product-option");
          pplrWrappers.forEach(wrapper => {
             const label = wrapper.dataset.type;
             const value = extractValueFromParams(decodedParams, label);
             if (value && wrapper.querySelector("select")) {
                wrapper.querySelector("select").value = value;
             }
             const values = extractValuesFromParams(decodedParams, label);
             if (values) {
                const checkboxes = wrapper.querySelectorAll('[type="checkbox"]');
                checkboxes.forEach(checkbox => {
                   checkbox.checked = values.includes(checkbox.value);
                });
    
                const radioboxes = wrapper.querySelectorAll('[type="radio"]');
                radioboxes.forEach(radiobox => {
                   radiobox.checked = values.includes(radiobox.value);
                  if(values.includes(radiobox.value)){
                    radiobox.setAttribute("data-last-clicked", "true")
                  }else {
                    radiobox.setAttribute("data-last-clicked", "false")
                  }
                });
             }
          });
          updateOptionsPrice(uniqueSelector);
       }

       function checkAnySelected(form){
         const productOptions = document.getElementById('product-options');
         const inputs = productOptions.querySelectorAll('input[type="checkbox"][required], input[type="radio"][required]');
         if(inputs.length==0) return false;
         const unselected = Array.from(inputs).filter(input => !input.checked);
         const noneSelected = unselected.length === inputs.length;
         const nativeVariantDoesntExist = document.querySelectorAll('.native-variant').length == 0;
         // console.log("noneSelected", noneSelected, nativeVariantDoesntExist, productOptions.hasChildNodes())
         return (noneSelected && nativeVariantDoesntExist && productOptions.hasChildNodes())
      }

      function checkAnySelectedMultiple(form, uniqueSelector){
         const productOptions = form.querySelector('#product-options');
         const inputs = productOptions.querySelectorAll('input[type="checkbox"][required], input[type="radio"][required]');
         if(inputs.length==0) return false;
         const unselected = Array.from(inputs).filter(input => !input.checked);
         const noneSelected = unselected.length === inputs.length;
         // const nativeVariantDoesntExist = form.querySelectorAll('.native-variant').length == 0; console.log(productOptions); console.log(form);
        
         if(window.location.href.includes("/cart")){
            const area = document.querySelector(`${uniqueSelector}`)
            const nativeVariantDoesntExist = Array.from(area.querySelectorAll('.native-variant')).every(variant => variant.closest('fieldset').style.display === 'none');
           // console.log("noneSelected", noneSelected, nativeVariantDoesntExist, productOptions.hasChildNodes())
           return (noneSelected && nativeVariantDoesntExist && productOptions.hasChildNodes())
          }
         else {
           const nativeVariantDoesntExist = Array.from(form.querySelectorAll('.native-variant')).every(variant => variant.closest('fieldset').style.display === 'none');
           // console.log("noneSelected", noneSelected, nativeVariantDoesntExist, productOptions.hasChildNodes())
           return (noneSelected && nativeVariantDoesntExist && productOptions.hasChildNodes())
         }
      }


       function openAndCloseCartAfterAdd() {
         try {
             const cartDrawer = document.querySelector('cart-drawer');
             if (cartDrawer) {
               setTimeout(() => {
                 cartDrawer.setAttribute('open', '');
                 setTimeout(() => {
                     cartDrawer.removeAttribute('open');
                 }, 2500);
               }, 800);

             } else {
                 console.error('cart-drawer element not found');
             }
         } catch (error) {
             console.error('Error in openAndCloseCartAfterAdd:', error);
         }
       }



       function addToCartInitializer(){
         ///////////////////////////////////////////////////////////////
         const addToCartForm = document.querySelector('form[is="product-form"]');
         const atcBtn = document.querySelector('product-form form .product-form__buttons .product-form__submit[type="submit"]');
         const atcText = document.querySelector('product-form form .product-form__buttons .product-form__submit[type="submit"] span');
         const loadingSpinner = document.querySelector('product-form form .product-form__buttons .product-form__submit[type="submit"] .loading__spinner');
         
         if (addToCartForm && window.hasSandwich) { // && false
            addToCartForm.addEventListener('submit', function(event) {
              // console.log("sub")
               ///////////////////////////////////////////////////////////////
               event.stopPropagation();
               event.preventDefault();

               if (requireLoginFoodify) if (!window.customerLoggedIn) { try { MicroModal.close(); document.querySelectorAll('.modal.is-open').forEach(el => el.classList.remove('is-open')); } catch (err) { console.error(err); } document.body.style.overflow = 'auto'; try { document.querySelector('#deliverify-main').style.pointerEvents = "none"; } catch (err) { console.error(err); } try { MicroModal.show('modal-login'); } catch (err) { console.error(err); } try { const submitButtons = Array.from(document.querySelectorAll(`${uniqueSelector} button[type="submit"]`)); submitButtons.forEach((submitButton) => { submitButton.removeAttribute("disabled"); submitButton.setAttribute("aria-busy", "false"); }); return; } catch (err) { console.error(err); } }
    
               /*  return  */
               /*  console.log("continue")  */
              
              const price = getPrice(uniqueSelector);
              
              const form = document.querySelector('form[action="/cart/add"][data-type="add-to-cart-form"][is="product-form"]');
              const formData1 = new FormData(form);
              
               if(checkAnySelected(form)){
                  const errorMessage = document.createElement('div');
                  const buttons = form.querySelector('.product-form__buttons');
                  if (!buttons) return;
                  Object.assign(errorMessage.style, { color: 'red', marginTop: '-20px', paddingBottom: '10px', display: 'block' });
                  form.insertBefore(errorMessage, buttons);
                  errorMessage.textContent = 'Please select an option.';
                     
                  setTimeout(() => {
                    const submitButtons = Array.from(form.elements).filter((button) => button.type === "submit");
                    submitButtons.forEach((submitButton) => {
                       submitButton.removeAttribute("disabled");
                       submitButton.removeAttribute("aria-busy");
                    });
                    atcText.style.opacity = "1"
                    atcBtn.removeAttribute("aria-busy");
                    atcBtn.removeAttribute("disabled");
                  }, 500);
                  setTimeout(() => {
                    errorMessage.style.display = 'none'; 
                  }, 1500);
                  return
                }
 

               if (Array.from(document.querySelectorAll(`${uniqueSelector} select[required]`)).some(select => !select.value)) {
                  const errorMessage = document.createElement('div');
                  const buttons = form.querySelector('.product-form__buttons');
                  if (!buttons) return;
                  Object.assign(errorMessage.style, { color: 'red', marginTop: '-20px', paddingBottom: '10px', display: 'block' });

                  const parentOfButtons = buttons.parentNode;
                  parentOfButtons.insertBefore(errorMessage, buttons);

                  const requiredSelects = Array.from(document.querySelectorAll(`${uniqueSelector} select[required]`)).filter(select => !select.value);
                  const legendNames = requiredSelects.map(select => {
                     const legend = select.closest('fieldset').querySelector('legend').textContent;
                     return legend.replace(/[:*].*/, '').trim();
                  });
                  
                  errorMessage.textContent = `Please select [${legendNames.join(', ')}].`;

                  setTimeout(() => {
                     const submitButtons = Array.from(form.elements).filter((button) => button.type === "submit");
                     submitButtons.forEach((submitButton) => {
                        submitButton.removeAttribute("disabled");
                        submitButton.removeAttribute("aria-busy");
                     });
                     if (typeof updateButtonText !== 'undefined') {
                        updateButtonText.style.opacity = "1";
                     }
                     if (typeof updateButton !== 'undefined') {
                        updateButton.removeAttribute("aria-busy");
                        updateButton.removeAttribute("disabled");
                     }
                  }, 500);
                  setTimeout(() => {
                    errorMessage.style.display = 'none'; 
                  }, 1500);
                  return
                }
 
               if (!onAddtoCart(form)) {return}
               createSandwich(formData1, form, price, atcBtn, atcText, loadingSpinner)
               ///////////////////////////////////////////////////////////////
            }); // end submit
         }

         async function createSandwich(formData1, form, price) {
           ///////////////////////////////////////////////////////////////
           //-console.log("create sandwich"); console.log(form.id.value); console.log(formData1); console.log(window.currentVariant?.variant_id ?? formValues.id);

           function getFormValues(form) {
            const inputs = form.elements;
            const values = {};
            Array.from(inputs).forEach(input => {
              if (!input.name) return;
              if (input.type === "checkbox" || input.type === "radio") {
                if (input.checked) {
                  values[input.name] = input.value;
                }
              } else {
                values[input.name] = input.value;
              }
            });
            return values;
          }
           const formValues = getFormValues(form);

           
           ///////////////////////////////////////////////////////////////
           // The item is already in the cart when this runs — reflect it
           // immediately instead of the old staged Processing../Added waits.
           setTimeout(() => {
             setTimeout(() => {
               atcBtn.removeAttribute('aria-busy'); 
               atcText.style.opacity = '1'
               atcText.textContent = 'Added'
               atcText.style.setProperty('color', `${highlight_text_color}`, 'important');
               atcBtn.style.setProperty('background', `${highlight_bg_color}`, 'important');
             }, '0')
             
             setTimeout(() => {
               atcBtn.disabled = false;
               atcText.textContent = 'Add To Cart'
               if(useArrow) {
                 atcText.style.setProperty('color', `${highlight_text_color}`, 'important');
                 atcBtn.style.setProperty('background', `${highlight_bg_color}`, 'important');
               }else {
                 atcText.style.setProperty('color', `${normal_text_color}`, 'important');
                 atcBtn.style.setProperty('background', `${normal_bg_color}`, 'important');
               }
             }, '1500')
             
             afterAddtoCart(form);
            }, 0);
           ///////////////////////////////////////////////////////////////
      
           try {
              ///////////////////////////////////////////////////////////////
              // TEST: Add directly to cart with custom price
              const variantId = window.currentVariant?.variant_id ?? formValues.id;
              
              // Get quantity from form (default to 1 if not found)
              const quantity = parseInt(formValues.quantity) || 1;
              
              // Add cart item with custom price
              const cartItem = {
                id: variantId,
                quantity: quantity,
                price: price, // The updateShopifyCart function will automatically add this as _price property
                properties: {} // Initialize properties object
              };
              
              // Add all form properties to the cart item
              Object.keys(formValues).forEach(key => {
                if (key !== 'id' && formValues[key]) {
                  cartItem.properties[key] = formValues[key];
                }
              });
              
              
              // Use the existing updateShopifyCart function with custom price
              updateShopifyCart([cartItem], formValues, form);
              
              form.setAttribute('data-form-ready', 'true');
              timer.stop('create');
              
              // COMMENTED OUT: Original Gadget API call
              /*
              const response = await fetch(url, {
                  method: 'POST',
                  headers: {
                     'Content-Type': 'application/json'
                  },
                  body: JSON.stringify(payload),
               });
              const data = await response.json();
              // const variantId = data.variantId.id.split("/").pop();
             // Jays routes returns just the actual variant id
             const variantId = data.variantId;
             const originalVariantId = data.parentVariantId;
              form.querySelector('input[name="id"]').value = variantId;
              form.setAttribute('data-form-ready', 'true');
              timer.stop('create')

             // Jays new add to cart function -> found in simple-add-to-cart.js
            updateShopifyCart([{id: variantId, quantity: 1, price: price}], formValues, form);

// console.log("Reseting current variant id to originalVariantId", originalVariantId);
             form.querySelector('input[name="id"]').value = originalVariantId;
// console.log("Reseting to originalVariantId completed", form.querySelector('input[name="id"]').value);                 


              // setTimeout(() => {
              //     addToCart2(form, data, variantId, currentProductId)
              //  }, 50); //" SET BACK"
              */
              ///////////////////////////////////////////////////////////////
            } 
           catch (error) {
               console.error('Error during cart add:', error);
               afterAddtoCart(form)
            }
           ///////////////////////////////////////////////////////////////
         }

         function onAddtoCart(form) {
            ///////////////////////////////////////////////////////////////
            if (form.getAttribute('data-form-ready') === "true") {
               // return;
            }
            if (loadingSpinner) {
               // loadingSpinner.classList.remove('hidden');
              if(document.querySelector('product-form form .product-form__buttons .product-form__submit[type="submit"]')){
                document.querySelector('product-form form .product-form__buttons .product-form__submit[type="submit"]').disabled = 'true'
                document.querySelector('product-form form .product-form__buttons .product-form__submit[type="submit"]').setAttribute('aria-busy', 'true');
              }
               
  
            }
            if (atcBtn) {
               atcText.style.opacity = "0";
            }
            const selectors = [
               'fieldset[data-not-included="true"] input',
               'fieldset[data-not-included="true"] select',
               'input[data-not-included="true"]',
               'select[data-not-included="true"]'
            ];
            const elementsToModify = document.querySelectorAll(selectors.join(','));
            elementsToModify.forEach(element => {
               element.removeAttribute('required');
            });
            const submitButtons = Array.from(form.elements).filter((button) => button.type === "submit");
            submitButtons.forEach((submitButton) => {
               submitButton.setAttribute("disabled", "disabled");
               submitButton.setAttribute("aria-busy", "true");
            });
            document.querySelector('product-form form .product-form__buttons .product-form__submit[type="submit"]').disabled = 'true'
            if (!form.checkValidity()) {
               form.reportValidity();
               submitButtons.forEach((submitButton) => {
                  submitButton.removeAttribute("disabled");
                  submitButton.removeAttribute("aria-busy");
               });
               //-console.log("validity error")
               if (loadingSpinner) {
                  loadingSpinner.classList.add('hidden');
               }
      
               if (atcBtn) {
                  atcText.style.opacity = "1";
               }

               //Jay commenting out due to after add to cart the form for some reason adds the 'required' attribtue to foodify options
               // elementsToModify.forEach(element => {
               //    element.setAttribute('required', '');
               // });
      
               return false;
            }
            return true;
            ///////////////////////////////////////////////////////////////
         }
         function afterAddtoCart(form) {
            ///////////////////////////////////////////////////////////////
            const selectors = [
               'fieldset[data-not-included="true"] input',
               'fieldset[data-not-included="true"] select',
               'input[data-not-included="true"]',
               'select[data-not-included="true"]'
            ];
            const elementsToModify = document.querySelectorAll(selectors.join(','));
            elementsToModify.forEach(element => {
               element.removeAttribute('required');
            });
            const submitButtons = Array.from(form.elements).filter((button) => button.type === "submit");
            submitButtons.forEach((submitButton) => {
               submitButton.removeAttribute("disabled");
               submitButton.removeAttribute("aria-busy");
            });
            if (loadingSpinner) {
               loadingSpinner.classList.add('hidden');
            }
            if (atcBtn) {
               atcText.style.opacity = "1";
            }
           
            //Jay commenting out due to after add to cart the form for some reason adds the 'required' attribtue to foodify options
            // elementsToModify.forEach(element => {
            //    element.setAttribute('required', '');
            // });
            document.querySelectorAll('#product-options select, #product-options input[type=checkbox], #product-options input[type=radio]').forEach(element => {
            if (element.type === 'checkbox' || element.type === 'radio') {
              element.checked = false;
            } else {
              element.selectedIndex = 0;
            }
            element.dispatchEvent(new Event('change', { bubbles: true }));
          });
            ///////////////////////////////////////////////////////////////
         }
         ///////////////////////////////////////////////////////////////
       }

       function addToCartInitializerMultiple(){
         
         waitForElmFoodify(`${uniqueSelector} .update-button`).then(() => {
           ///////////////////////////////////////////////////////////////
           const updateButton = document.querySelector(`${uniqueSelector} .update-button`)
           const updateButtonText = updateButton.querySelector(`span`)
           
           if(window.location.href.includes("/collections") && !window.location.pathname.includes("/products/")) { updateButton.querySelector("span").textContent = 'Add To Cart'; }
              
           updateButton.addEventListener('click', function(event) {
               event.stopPropagation();
               event.preventDefault();
  
               window.variant_sku = updateButton.getAttribute('data-variant-sku');
               window.variant_title = updateButton.getAttribute('data-variant-title');
               let linekey = updateButton.getAttribute('data-update-line-key') || null;

               /*  console.log(requireLoginFoodify, !window.customerLoggedIn)  */

               if (requireLoginFoodify) if (!window.customerLoggedIn) { try { MicroModal.close(); document.querySelectorAll('.modal.is-open').forEach(el => el.classList.remove('is-open')); } catch (err) { console.error(err); } document.body.style.overflow = 'auto'; try { document.querySelector('#deliverify-main').style.pointerEvents = "none"; } catch (err) { console.error(err); } try { MicroModal.show('modal-login'); } catch (err) { console.error(err); } try { const submitButtons = Array.from(document.querySelectorAll(`${uniqueSelector} button[type="submit"]`)); submitButtons.forEach((submitButton) => { submitButton.removeAttribute("disabled"); submitButton.setAttribute("aria-busy", "false"); }); return; } catch (err) { console.error(err); } }
    

               /*  return  */
               /*  console.log("continue")  */
                                 
               window.currentUpdateButton = updateButton;
               updateButton.disabled = true;
               updateButton.setAttribute('aria-busy', 'true');
                          
               if(updateButton.querySelector('.loading__spinner')){ updateButton.querySelector('.loading__spinner').classList.remove('hidden'); }
               if(updateButton.querySelector('span')){ updateButton.querySelector('span').style.opacity = '0'; }                                          

               // return
               const price = getPrice(uniqueSelector);
               
               let form = undefined;
               if((window.location.href.includes("/collections") && !window.location.pathname.includes("/products/")) || window.location.href.includes("/search")) {
                 // Legacy cards: the wrapper form Shopify auto-ids as
                 // product_form_<id>. Tile cards render only the modal's own
                 // form (product-options-v2) — fall back to it by location.
                 form = document.querySelector(`.product-card-info-area form[action="/cart/add"][is="product-form"]#product_form_${uniqueSelector.replace(".modal#modal-","")} `)
                     || document.querySelector(`${uniqueSelector} form[action="/cart/add"][is="product-form"]`);
               }
               else {
                  form = document.querySelector(`${uniqueSelector} form[action="/cart/add"][data-type="add-to-cart-form"][is="product-form"]`);
               }
               const formData1 = new FormData(form);
             
               if(checkAnySelectedMultiple(form, uniqueSelector)){
                  const errorMessage = document.createElement('div');
                  errorMessage.classList.add('modal-error-x')
                  const buttons = form.querySelector('footer.modal__footer') || document.querySelector(`${uniqueSelector} footer.modal__footer`);
                  if (!buttons) return;
                  Object.assign(errorMessage.style, { color: 'red', marginTop: '-20px', paddingBottom: '10px', display: 'block', paddingInline: '40px' });
                  const parentOfButtons = buttons.parentNode;
                  parentOfButtons.insertBefore(errorMessage, buttons);
                  errorMessage.textContent = 'Please select an option.';
              
                  setTimeout(() => {
                    const submitButtons = Array.from(form.elements).filter((button) => button.type === "submit");
                    submitButtons.forEach((submitButton) => {
                       submitButton.removeAttribute("disabled");
                       submitButton.removeAttribute("aria-busy");
                    });
                    updateButtonText.style.opacity = "1"
                    updateButton.removeAttribute("aria-busy");
                    updateButton.removeAttribute("disabled");
                  }, 500);
                  setTimeout(() => {
                    errorMessage.style.display = 'none'; 
                  }, 1500);
                  return
                }
             


               if (Array.from(document.querySelectorAll(`${uniqueSelector} select[required]`)).some(select => !select.value)) {
                  const errorMessage = document.createElement('div');
                  errorMessage.classList.add('modal-error-x');
                  const buttons = form.querySelector('footer.modal__footer') || document.querySelector(`${uniqueSelector} footer.modal__footer`);
                  if (!buttons) return;
                  Object.assign(errorMessage.style, { color: 'red', marginTop: '-20px', paddingBottom: '10px', display: 'block', paddingInline: '40px' });

                  const parentOfButtons = buttons.parentNode;
                  parentOfButtons.insertBefore(errorMessage, buttons);

                  const requiredSelects = Array.from(document.querySelectorAll(`${uniqueSelector} select[required]`)).filter(select => !select.value);
                  const legendNames = requiredSelects.map(select => {
                     const legend = select.closest('fieldset').querySelector('legend').textContent;
                     return legend.replace(/[:*].*/, '').trim();
                  });
                  
                  errorMessage.textContent = `Please select [${legendNames.join(', ')}].`;

                  setTimeout(() => {
                     const submitButtons = Array.from(form.elements).filter((button) => button.type === "submit");
                     submitButtons.forEach((submitButton) => {
                        submitButton.removeAttribute("disabled");
                        submitButton.removeAttribute("aria-busy");
                     });
                     if (typeof updateButtonText !== 'undefined') {
                        updateButtonText.style.opacity = "1";
                     }
                     if (typeof updateButton !== 'undefined') {
                        updateButton.removeAttribute("aria-busy");
                        updateButton.removeAttribute("disabled");
                     }
                  }, 500);

                  setTimeout(() => {
                     errorMessage.style.display = 'none';
                  }, 1500);

                  return;
               }

             
               createSandwich(formData1, form, price, linekey)
             }); 
  
           async function createSandwich(formData1, form, price, linekey) {
             ///////////////////////////////////////////////////////////////
             // console.log("create sandwich"); console.log(form); console.log(form.querySelector('input[name="id"]').value); console.log(form.id.value);
             let variantID = form.querySelector('input[name="id"]').value;

             function getFormValues(form) {
              const inputs = form.elements;
              const values = {};
              Array.from(inputs).forEach(input => {
                if (!input.name) return;
                if (input.type === "checkbox" || input.type === "radio") {
                  if (input.checked) {
                    values[input.name] = input.value;
                  }
                } else {
                  values[input.name] = input.value;
                }
              });
              return values;
            }
             const formValues = getFormValues(form);

  
             ///////////////////////////////////////////////////////////////
             // The item is already in the cart when this runs — show Added
             // now, close the modal right after, no staged waits.
             setTimeout(() => {
               setTimeout(() => {
                 updateButton.removeAttribute('aria-busy'); 
                 updateButtonText.style.opacity = '1'
                 updateButtonText.textContent = 'Added'
                 updateButtonText.style.setProperty('color', `${highlight_text_color}`, 'important');
                 updateButton.style.setProperty('background', `${highlight_bg_color}`, 'important');
                 document.body.style.overflow = "auto";
               }, '0')
               
               setTimeout(() => {
                 updateButton.disabled = false;
                 updateButtonText.textContent = 'Add To Cart'
                 if(useArrow) {
                   updateButtonText.style.setProperty('color', `${highlight_text_color}`, 'important');
                   updateButton.style.setProperty('background', `${highlight_bg_color}`, 'important');
                 }else {
                   updateButtonText.style.setProperty('color', `${normal_text_color}`, 'important');
                   updateButton.style.setProperty('background', `${normal_bg_color}`, 'important');
                 }
               }, '1400')
  
               setTimeout(() => { 
                 try{MicroModal.close(); document.querySelectorAll('.modal.is-open').forEach(el => el.classList.remove('is-open'));}catch(e){} 
                 document.body.style.overflow = 'auto';
                 try{document.querySelector('#deliverify-main').style.pointerEvents = "none"}catch(err){}
                 
                 if (window.location.href.includes('/cart')) {
                   window.location.reload();
                   return;
                 }

                 setTimeout(() => { 
                   document.querySelectorAll(`${uniqueSelector} #product-options select, ${uniqueSelector}  #product-options input[type=checkbox], ${uniqueSelector}  #product-options input[type=radio]`).forEach(element => {
                    if (element.type === 'checkbox' || element.type === 'radio') {
                      element.checked = false;
                    } 
                    else {
                      element.selectedIndex = 0;
                    }
                   });
                 }, '100')
               }, '900')
               
               afterAddtoCart(form);
              }, 0);
             ///////////////////////////////////////////////////////////////
        
             try {
                ///////////////////////////////////////////////////////////////
                // TEST: Add directly to cart with custom price
                const variantId = variantID;
                
                // Get quantity from modal input or form (default to 1 if not found)
                const modalQtyInput = window.currentUpdateButton?.closest('.modal__footer')?.querySelector('.quantity__input')
                  || window.currentUpdateButton?.closest('.modal')?.querySelector('.quantity__input')
                  || document.querySelector(`${uniqueSelector} .quantity__input`);
                const quantity = parseInt(modalQtyInput?.value || formValues.quantity) || 1;
                
                // Add cart item with custom price
                const cartItem = {
                  id: variantId,
                  quantity: quantity,
                  price: price, // The updateShopifyCart function will automatically add this as _price property
                  properties: {} // Initialize properties object
                };
                
                // Add all form properties to the cart item
                Object.keys(formValues).forEach(key => {
                  if (key !== 'id' && formValues[key]) {
                    cartItem.properties[key] = formValues[key];
                  }
                });
                
                
                // Use the existing updateShopifyCart function with custom price
                updateShopifyCart([cartItem], formValues, form, linekey);
                
                form.setAttribute('data-form-ready', 'true');
                
                // COMMENTED OUT: Original Gadget API call
                /*
                const response = await fetch(url, {
                    method: 'POST',
                    headers: {
                       'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(payload),
                 });
                const data = await response.json();
                const variantId = data.variantId;
                const originalVariantId = data.parentVariantId;
                form.querySelector('input[name="id"]').value = variantId;
                form.setAttribute('data-form-ready', 'true');
  
                // Jays new add to cart function -> found in simple-add-to-cart.js
                updateShopifyCart([{id: variantId, quantity: 1, price: price}], formValues, form, linekey);
                form.querySelector('input[name="id"]').value = originalVariantId;           
                */
                ///////////////////////////////////////////////////////////////
              } 
             catch (error) {
                 console.error('Error during cart add:', error);
                 afterAddtoCart(form)
              }
             ///////////////////////////////////////////////////////////////
           }

           function afterAddtoCart(form) {
              const selectors = [
                 'fieldset[data-not-included="true"] input',
                 'fieldset[data-not-included="true"] select',
                 'input[data-not-included="true"]',
                 'select[data-not-included="true"]'
              ];
              const elementsToModify = document.querySelectorAll(selectors.join(','));
              
              // Jay commenting out due to after add to cart the form for some reason adds the 'required' attribtue to foodify options
              // elementsToModify.forEach(element => {  element.removeAttribute('required');  });
        
              const submitButtons = Array.from(form.elements).filter((button) => button.type === "submit");
        
              submitButtons.forEach((submitButton) => {
                 submitButton.removeAttribute("disabled");
                 submitButton.removeAttribute("aria-busy");
                 // console.log(submitButton)
                 const spanElement = submitButton.querySelector('span:not(.button__loader)');
                 if (spanElement) {spanElement.style.opacity = '1';}
              });        
           }
           ///////////////////////////////////////////////////////////////  
         });
       }
      
       if(!forMultiple){
         addToCartInitializer()
       }
       else {
         addToCartInitializerMultiple()
       } 
       ///////////////////////////////////////////////////////////////
  
    } //end foodify
